export const translations = {
  de: {
    // ==================== HEADER ====================
    header: {
      // Navigation
      produkte: 'Produkte',
      anwender: 'Anwender',
      unternehmen: 'Unternehmen',

      // Language
      language: 'DE',
      deutsch: 'Deutsch',
      english: 'English',

      // CTA
      ctaButton: 'KONTAKT ANFRAGEN',

      // Produkte Dropdown
      angebotserstellung: {
        title: 'Angebotserstellung Anmietverkehr',
        description: 'Lassen Sie Ihre Angebotserstellung vollautomatisiert für sich laufen.'
      },
      umlaufUndDienstplanung: {
        title: 'Umlauf- und Dienstplanung',
        description: 'Intelligente Planung statt Checklisten. Alles in einer Software per Knopfdruck.'
      },
      disposition: {
        title: 'Disposition',
        description: 'Moderne Lösung für reibungslose Betriebszuweisung mit Admin- und Fahrer-Dashboard. Intelligente Umplanung, sobald mal etwas nicht nach Plan läuft!'
      },
      fehlermeldung: {
        title: 'Fehlermeldung',
        description: 'Sekundenschnelle Schadensmeldung per QR-Code oder NFC - automatische Disposition inklusive.'
      },
      lohnabrechnung: {
        title: 'Lohnabrechnung',
        description: 'Ein Knopfdruck - fertige Lohnabrechnung direkt beim Steuerberater. Keine Extra-Software, keine Extra-Kosten!'
      },

      // Anwender Dropdown
      nachAnwendern: 'NACH ANWENDERN',
      nachAnwendungsfall: 'NACH ANWENDUNGSFALL',

      verkehrsverbuende: {
        title: 'Verkehrsverbünde und Aufgabenträger',
        description: 'Netzwerke optimieren, Effizienz steigern und die Kommunikation mit den Fahrgästen verbessern'
      },
      verkehrsunternehmen: {
        title: 'Verkehrsunternehmen',
        description: 'Fahrzeugnutzung optimieren, gemischte Flotten verwalten und Kosten senken'
      },
      fahrpersonalBinden: {
        title: 'Fahrpersonal binden',
        description: 'Steigern Sie die Zufriedenheit Ihres Fahrpersonals durch optimierte Schichtplanung'
      },
      fahrgastzufriedenheit: {
        title: 'Fahrgastzufriedenheit',
        description: 'Steigerung der Kundenzufriedenheit durch besseren Service!'
      },
      betriebskostenSenken: {
        title: 'Betriebskosten senken',
        description: 'Effizienz steigern und Ressourcen besser nutzen – bei verbesserter Servicequalität'
      },

      // Unternehmen Dropdown
      ueberUns: 'Über uns',
      kontakt: 'Kontakt',
      career: 'Career',
      veranstaltungen: 'Veranstaltungen'
    },

    // ==================== HERO SECTION ====================
    hero: {
      title: 'Dispo, automatisiert. Planung, optimiert.',
      titleMobile: 'Dispo, automatisiert.\nPlanung, optimiert.',
      subtitle: 'Für deutsche Busunternehmen: Robuste Prozesse, bessere Schichten, zufriedene Fahrgäste. Alles in einer Plattform.',
      ctaButton: 'KONTAKT ANFRAGEN',
      imageAlt: 'Busfahrer begrüßt einen Fahrgast'
    },

    // ==================== STATS SECTION ====================
    stats: {
      cities: 'Städte',
      tripsNumber: '350.000',
      trips: 'Fahrten pro Jahr',
      savingsNumber: '4,5 Millionen',
      savings: 'Euro gespart'
    },

    // ==================== PLATFORM SECTION ====================
    platform: {
      mainTitle: 'Smarte Planung per Knopfdruck.',
      mainSubtitle: 'Übersichtlich, Benutzerfreundlich, Effizient',
      highlights: 'Die Highlights von BusAgent',
      ctaButton: 'MEHR ERFAHREN',

      // Tabs
      tabs: {
        plattform: {
          label: 'Plattform',
          title: 'Plattform',
          description: 'Unsere Plattform bietet nicht nur all das, was Ihr bestehendes Dispositionsprogramm kann, sondern weitaus mehr.'
        },
        angebotsplanung: {
          label: 'Angebotsplanung',
          title: 'Angebotsplanung',
          description: 'Busunternehmer kennen es: Eine Anfrage kommt rein, diese muss man ggf. mit einem Zusatzprogramm nochmal verarbeiten und dann schickt man dem Kunden ein Angebot zurück. Mit BusAgent haben Sie die Wahl. Sie können grundsätzlich zum einen ALLES noch per Hand machen, und selbst das fällt Ihnen einfacher, als mit bestehenden alten Lösungen. Und zum anderen KI nutzen, um Ihre Angebotsplanung für den Anmietverkehr passiv aufs nächste Level zu bringen. Keine "Sondermodule", Kein "Aufpreis". Alles in einem Packet.'
        },
        umlaufDienstplanung: {
          label: 'Umlauf- und Dienstplanung',
          title: 'Umlauf- und Dienstplanung',
          description: 'Lassen Sie Fahrzeugumläufe und Dienst effizient für sich planen. Die Planung erfolgt per Knopfdruck und über den BusAgent Algorithmus voll automatisiert. Sparen Sie nicht nur Kosten in der Dispo, sondern durch die Dispo. Lassen Sie die Software für sich arbeiten und nicht andersrum!'
        }
      }
    },

    // ==================== SOLUTIONS SECTION ====================
    solutions: {
      title: 'Ob öffentlich oder privat, ob groß oder klein –',
      titleBreak: 'BusAgent hat für alles eine Lösung.',
      loadingText: 'Animationen werden geladen...',

      items: {
        agencies: 'Aufgabenträger',
        cities: 'Städte',
        operators: 'Verkehrsunternehmen',
        events: 'Veranstaltungen',
        corporations: 'Firmen',
        consultancies: 'Beratungsunternehmen',
        universities: 'Universitäten'
      }
    },

    // ==================== CUSTOMERS SECTION ====================
    customers: {
      title: 'Unsere Kunden',
      prevQuote: 'Vorheriges Zitat',
      nextQuote: 'Nächstes Zitat',
      quoteNumber: 'Zitat',

      quotes: [
        {
          text: 'War tatsächlich einer der ersten Kunden. Damals waren es nur die drei, und jetzt habe ich da meinen eigenen Betreuer. Bin sehr zufrieden mit Support und den Custom-Anpassungen, die ich haben wollte. Habe es mir wegen der Dienst- und Umlaufplanung geholt und da liefert BusAgent tatsächlich Unglaubliches! Sehr positiv überrascht!',
          author: 'Maurice Litz',
        },
        {
          text: 'Tatsächlich hatte ich erst keine Lust auf das „Umsteigen" auf eine neue Software. Aber da BusAgent die manuellen Features sowieso ähnlich wie bei den alten Softwares hat, ist das kein Problem gewesen. Meine Disponenten nutzen die manuellen Features sowieso so gut wie gar nicht mehr, da man sowieso nur einen Knopf bedienen muss!',
          author: 'Achim Schwarz',
        },
        {
          text: 'Hatte vorher 4 Disponenten... Hat sich gezeigt, dass ich wohl doch nicht alle 4 in der Disposition brauche. Habe jetzt tatsächlich so um die 9.000-11.000 Euro mehr Kleingeld, um es woanders als in die Dispo zu stecken. Bin sehr froh, das hier gemacht zu haben!',
          author: 'Borchard Vogt',
        },
        {
          text: 'Software zu bedienen ist unglaublich easy. Habe ich vorher alles selbst gemacht und jetzt wird mir einfach so viel Arbeit abgenommen, echt tolles Zeug!',
          author: 'Julia Becker',
        },
        {
          text: 'Bin ja selber ein bisschen der Techniker hier bei uns, und ich bin echt begeistert. Ich habe zwar keine Einsicht in den Quellcode, aber man muss echt krass drauf sein, so etwas entwickeln zu können!',
          author: 'Björn Riedel',
        },
        {
          text: 'Ich habe jetzt nicht die genauen Zahlen, aber ich musste manchmal einfach wirklich Strafen zahlen, einfach nur, weil mein Disponent zu inkompetent war, Lenkzeiten richtig einzuplanen. Mit BusAgent ist das nicht nur nicht mehr vorgekommen, sondern ich bin mir unheimlich sicher, dass wir DEUTLICH geringere Spritkosten haben... Da bleibt am Ende des Monats mehr für mich übrig :)',
          author: 'Marcel Dahm',
        }
      ]
    },

    // ==================== HIRING CTA SECTION ====================
    hiringCTA: {
      title: 'Wir haben Großes vor und wollen deutsche Busunternehmen gemeinsam besser machen!',
      subtitle: 'Sie möchten etwas bewegen?',
      ctaButton: 'STEIGEN SIE EIN',
      imageAlt: 'Team sitzt zusammen und lacht'
    },

    // ==================== DEMO CTA SECTION ====================
    demoCTA: {
      title: 'Überzeugen Sie sich selbst von der',
      titleHighlight: 'Leistungsfähigkeit von BusAgent.',
      ctaButton: 'KONTAKT ANFRAGEN'
    },

    // ==================== FOOTER ====================
    footer: {
      produkte: {
        title: 'Produkte',
        angebotserstellung: 'Angebotserstellung',
        umlaufDienstplanung: 'Umlauf- und Dienstplanung',
        disposition: 'Disposition',
        fehlermeldung: 'Fehlermeldung',
        lohnabrechnung: 'Lohnabrechnung',
        fuerArztpraxen: 'FÜR ARZTPRAXEN',
        diktieragent: 'DiktierAgent'
      },
      anwender: {
        title: 'Anwender',
        nachAnwendern: 'NACH ANWENDERN',
        verkehrsunternehmen: 'Verkehrsunternehmen',
        verkehrsverbuende: 'Verkehrsverbünde',
        nachAnwendungsfall: 'NACH ANWENDUNGSFALL',
        fahrpersonalBinden: 'Fahrpersonal binden',
        fahrgastzufriedenheit: 'Fahrgastzufriedenheit',
        betriebskostenSenken: 'Betriebskosten senken'
      },
      unternehmen: {
        title: 'Unternehmen',
        ueberUns: 'Über uns',
        career: 'Career',
        kontakt: 'Kontakt',
        veranstaltungen: 'Veranstaltungen'
      },
      legal: {
        title: 'Legal',
        impressum: 'Impressum',
        datenschutz: 'Datenschutz',
        nutzungsbedingungen: 'Nutzungsbedingungen'
      },
      ctaButton: 'KONTAKT ANFORDERN'
    },

    // ==================== ANGEBOTSERSTELLUNG PAGE ====================
    angebotserstellungPage: {
      hero: {
        title: 'Angebots\u00ADerstellung vollständig automatisiert',
        subtitle: 'Schluss mit manuellen Prozessen! BusAgent revolutioniert Ihre Angebotserstellung über alle Kanäle - Telefon, E-Mail und Website - mit intelligenter KI-Unterstützung.',
        ctaPrimary: 'KONTAKT ANFRAGEN',
        ctaSecondary: 'MEHR ERFAHREN',
        channels: {
          phone: {
            title: 'Telefon',
            description: 'KI extrahiert Infos aus Gesprächen'
          },
          email: {
            title: 'E-Mail',
            description: 'LLM liest und verarbeitet Anfragen'
          },
          website: {
            title: 'Website',
            description: 'Direkte CRM-Integration'
          }
        }
      },
      problem: {
        title: 'Das Problem: Manuelle Angebotserstellung kostet Zeit und Geld',
        subtitle: 'Viele Unternehmen arbeiten noch mit veralteten Prozessen - Anfragen per E-Mail, Telefon oder über Formulare werden manuell bearbeitet. Das führt zu Verzögerungen, Fehlern und verpassten Chancen.',
        challenges: {
          timeConsuming: {
            title: 'Zeitaufwändig',
            description: 'Manuelle Dateneingabe und Bearbeitung jeder einzelnen Anfrage'
          },
          errorProne: {
            title: 'Fehleranfällig',
            description: 'Übertragungsfehler und inkonsistente Angebote'
          },
          noIntegration: {
            title: 'Keine Integration',
            description: 'Isolierte Systeme ohne Verbindung zur Angebotssoftware'
          }
        }
      },
      solution: {
        title: 'Die Lösung: BusAgent automatisiert alle Kanäle',
        subtitle: 'Ein in BusAgent integriertes CRM-System, das alle Anfragen automatisch erfasst, verarbeitet und in professionelle Angebote verwandelt.',
        website: {
          title: 'Website-Formulare',
          description: 'Ihre bestehenden Website-Formulare werden direkt mit dem BusAgent CRM verbunden, oder falls nicht vorhanden neu erstellt. Jede Anfrage landet automatisch im System und wird sofort verarbeitet.',
          benefits: {
            integration: 'Nahtlose Integration in bestehende Formulare',
            transfer: 'Automatische Datenübertragung ins CRM',
            instant: 'Sofortige Angebotsvorschläge'
          },
          form: {
            company: 'Unternehmen',
            companyPlaceholder: 'Transport GmbH',
            departure: 'Abfahrtsort',
            departurePlaceholder: 'Berlin',
            arrival: 'Ankunftsort',
            arrivalPlaceholder: 'Hamburg',
            setDeparture: 'Abfahrt festlegen',
            setArrival: 'Ankunft festlegen',
            departureDate: 'Abfahrtsdatum',
            arrivalDate: 'Ankunftsdatum',
            departureTime: 'Abfahrtszeit',
            arrivalTime: 'Ankunftszeit',
            passengers: 'Anzahl Personen',
            passengersPlaceholder: '50',
            submit: 'Angebot anfordern',
            crmNote: '→ Direkt ins BusAgent CRM'
          }
        },
        phone: {
          title: 'Telefon mit KI-Assistent',
          description: 'Die BusAgent KI erkennt automatisch Angebotsanfragen während des Telefonats und extrahiert alle relevanten Informationen in Echtzeit.',
          benefits: {
            recognition: 'Automatische Erkennung von Angebotsanfragen',
            extraction: 'Intelligente Datenextraktion aus Gesprächen',
            confirmation: 'Bestätigung vor CRM-Übertragung'
          },
          demo: {
            incoming: 'Eingehender Anruf',
            aiActive: 'KI-Assistent aktiv',
            step1: '1. "Ich erkenne Ihre Angebotsanfrage..."',
            step2: '2. Extrahiere: Route, Zeitraum...',
            step3: '3. Daten ins CRM übertragen'
          }
        },
        email: {
          title: 'E-Mail mit LLM-Verarbeitung',
          description: 'Unser fortschrittliches Language Model liest und versteht eingehende E-Mails, extrahiert alle relevanten Informationen und erstellt strukturierte Datensätze.',
          benefits: {
            understanding: 'Intelligentes Textverständnis',
            categorization: 'Automatische Kategorisierung',
            structured: 'Strukturierte Datenerfassung'
          },
          demo: {
            from: 'Von: kunde@beispiel.de',
            subject: 'Betreff: Anfrage Busverbindung',
            content: '"Wir benötigen ein Angebot für Reise Verbindung zwischen..."',
            extraction: 'LLM Extraktion:',
            route: '✓ Route: A → B',
            time: '✓ Uhrzeit Abfahrt: 09:00 Uhr',
            passengers: '✓ Fahrgäste: 73'
          }
        }
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFRAGEN'
      }
    },

    // ==================== UMLAUF UND DIENSTPLANUNG PAGE ====================
    umlaufPage: {
      hero: {
        title: 'Intelligente Umlaufplanung statt Checklisten',
        subtitle: 'BusAgent denkt mit: Automatische Zuteilung durch Smart-Algorithmen statt manueller Abarbeitung von Listen. Sparen Sie Zeit, Geld und Ressourcen.',
        ctaPrimary: 'KONTAKT ANFRAGEN',
        ctaSecondary: 'MEHR ERFAHREN',
        videoLabel: 'INTELLIGENTE DISPOSITION'
      },
      evolution: {
        title: 'Von Papier zur Intelligenz: Die Evolution der Umlaufsplanung',
        paperBased: {
          title: 'Papierbasiert',
          description: 'Manuelle Listen, unleserliche Notizen, verlorene Zettel',
          cons: {
            timeConsuming: 'Zeitaufwändig',
            errorProne: 'Fehleranfällig',
            noOverview: 'Keine Übersicht',
            inefficient: 'Ineffizient'
          }
        },
        traditional: {
          title: 'Bisherige-Software',
          description: 'Digitale Listen die zeigen, was noch zu tun ist',
          pros: {
            digital: 'Digital erfasst'
          },
          cons: {
            manual: 'Manuelle Zuteilung',
            noOptimization: 'Keine Optimierung'
          }
        },
        busAgent: {
          title: 'BusAgent',
          description: 'Algorithmus denkt mit und teilt automatisch optimal zu',
          pros: {
            automatic: 'Automatische Zuteilung',
            optimization: 'Algorithmische-Optimierung',
            savings: 'Ressourcen sparen'
          }
        }
      },
      difference: {
        title: 'Der entscheidende Unterschied: Mitdenken statt Abhaken',
        traditional: {
          title: 'Herkömmliche Software',
          intro: 'Bestehende Lösungen funktionieren wie digitale Checklisten:',
          points: {
            showTodo: 'Zeigen nur, was noch zu tun ist',
            manual: 'Manuelle Zuteilung erforderlich',
            check: 'Prüfen nur im Nachhinein',
            noOptimization: 'Keine intelligente Optimierung'
          },
          quote: 'Sie arbeiten immer noch die Liste ab - nur digital.'
        },
        busAgent: {
          title: 'BusAgent',
          intro: 'BusAgent denkt aktiv mit und übernimmt die Arbeit:',
          points: {
            automated: 'Erledigt Aufgaben per Knopfdruck',
            automatic: 'Automatische Algorithmische Zuteilung',
            realtime: 'Optimiert in Echtzeit',
            savings: 'Spart Ressourcen und Geld'
          },
          quote: 'Die Software arbeitet für Sie - nicht umgekehrt.'
        }
      },
      features: {
        speed: {
          title: 'Umlauf– und Dienstplanung in Höchstgeschwindigkeit',
          description: 'Die Optimierung der Dienste und Fahrzeuge erfolgt in Sekunden bis Minuten, nicht in Stunden oder Tagen. So können Sie mehrere Szenarien durchspielen und das beste Ergebnis auswählen. Unsere Technologie beschleunigt nicht nur den gesamten Planungsprozess, sondern ermöglicht es Ihnen auch, die Auswirkungen anhand der ständig aktualisierten Geschäftskennzahlen zu überprüfen.'
        },
        quality: {
          title: 'Umlaufplanungssoftware, die qualitativ hochwertige Ergebnisse liefert',
          description: 'Die Berücksichtigung sämtlicher Regeln und Einschränkungen wie beispielsweise Ablösefahrzeuge, Fahrzeugtypen und Lenkzeiten garantiert, dass die daraus resultierenden Umlaufpläne eine hohe Qualität aufweisen. Das wiederum wirkt sich unmittelbar auf die Dienstplanung aus.'
        },
        integration: {
          title: 'Integrierte Umlauf- und Dienstplanoptimierung',
          description: 'Die Möglichkeit, Fahrzeuge und Dienste (einschließlich Ablösefahrzeuge) gleichzeitig zu optimieren, ermöglicht einen besonderen Mehrwert. So können Fahrzeugumläufe erstellt werden und dabei Dienstpläne verbessert werden oder umgekehrt. So werden die Ressourcen bestmöglich eingesetzt. Durch die Einbindung von Ablösefahrzeugen in das System werden optimierte Fahrzeug- und Dienstpläne in kürzerer Zeit und zu niedrigeren Kosten erstellt. Bei der integrierten Optimierung werden alle Parameter gemeinsam betrachtet und verbessert, was Zeitersparnis, Fehlervermeidung und Kostensenkung ermöglicht.'
        }
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFRAGEN'
      }
    },

    // ==================== FEHLERMELDUNG PAGE ====================
    fehlermeldungPage: {
      hero: {
        title: 'Fehlermeldung in Sekunden',
        subtitle: 'Von der Schadensmeldung bis zur automatischen Disposition - alles mit einem Scan',
        ctaButton: 'KONTAKT ANFRAGEN',
        imageAlt: 'Fehlermeldung System'
      },
      process: {
        title: 'So einfach funktioniert\'s',
        steps: [
          {
            number: '1',
            title: 'Installation',
            description: 'Unser Techniker installiert QR-Codes oder NFC-Chips in jedem Fahrzeug'
          },
          {
            number: '2',
            title: 'Meldung',
            description: 'Fahrer scannt Code/Chip und meldet Schäden in Sekunden'
          },
          {
            number: '3',
            title: 'Disposition',
            description: 'Fahrzeug wird automatisch als nicht verfügbar markiert'
          },
          {
            number: '4',
            title: 'Reparatur',
            description: 'Nach Reparatur: Ein Scan genügt zur Wiederfreigabe'
          }
        ]
      },
      details: {
        title: 'Der komplette Ablauf im Detail',
        step1: {
          title: 'Kostenlose Installation',
          description: 'Ein BusAgent-Techniker kommt zu Ihnen und installiert in jedem Fahrzeug einen QR-Code oder NFC-Chip. Diese Einrichtung ist vollständig im Softwarepreis enthalten - keine zusätzlichen Kosten!',
          benefits: {
            professional: 'Professionelle Installation vor Ort',
            technology: 'Wahlweise QR-Code oder NFC-Technologie',
            noCost: 'Keine Zusatzkosten'
          },
          imageLabel: 'QR-Code & NFC-Chips'
        },
        step2: {
          title: 'Blitzschnelle Schadensmeldung',
          description: 'Der Busfahrer entdeckt einen Schaden? Ein kurzer Scan des QR-Codes oder NFC-Chips genügt. Es öffnet sich automatisch ein Online-Formular - keine App-Installation nötig!',
          process: {
            scan: 'Code/Chip scannen',
            photo: 'Foto vom Schaden hochladen (optional)',
            description: 'Kurze Beschreibung hinzufügen',
            submit: 'Absenden - fertig!'
          },
          imageLabel: 'Foto-Upload in Sekunden'
        },
        step3: {
          title: 'Automatische Disposition',
          description: 'Sobald die Meldung eingeht, passiert alles automatisch: Das Fahrzeug wird im Dispositionssystem als nicht verfügbar markiert und der intelligente Algorithmus plant es nicht mehr ein.',
          status: {
            blocked: 'Fahrzeug gesperrt',
            notified: 'Werkstatt informiert'
          },
          optimizationLabel: 'Algorithmisch optimierte Disposition'
        },
        step4: {
          title: 'Einfache Wiederfreigabe',
          description: 'Nach der Reparatur genügt ein erneuter Scan in der Werkstatt oder ein Klick im Dashboard. Das Fahrzeug ist sofort wieder für die Disposition verfügbar.',
          methods: {
            scan: 'Scan in Werkstatt',
            or: 'oder',
            dashboard: 'Klick im Dashboard'
          }
        }
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFRAGEN'
      }
    },

    // ==================== DISPOSITION PAGE ====================
    dispositionPage: {
      hero: {
        title: 'BusAgent Disposition',
        subtitle: 'Die moderne Lösung für eine reibungslose Betriebszuweisung – heute und in Zukunft',
        ctaButton: 'KONTAKT ANFRAGEN',
        videoLabel: 'LIVE DISPOSITION'
      },
      intro: {
        title: 'Ihre Busse und Fahrer:innen arbeiten in Echtzeit – Ihre Dispositionssoftware jetzt auch.',
        paragraphs: {
          p1: 'Mit BusAgent Disposition präsentieren wir das erste Betriebszuweisungssystem, das in Echtzeit mit Ihrem Betrieb mitdenkt.',
          p2: 'Die Lösung wurde gemeinsam mit Verkehrsunternehmern von Grund auf neu entwickelt – basierend auf realen Anforderungen, intensiven Tests und praxisnahen Rückmeldungen. Das Ergebnis: Eine passgenaue, zukunftsfähige Lösung, die Ihre operativen Herausforderungen wirklich löst.',
          p3: 'BusAgent Disposition entwickelt sich kontinuierlich weiter – damit Sie schon heute auf die Anforderungen von morgen vorbereitet sind.'
        }
      },
      features: {
        title: 'Was Ihnen BusAgent Disposition bietet:',
        accordion: {
          item1: {
            title: 'Tägliche Zuweisung &<br/>Echtzeit-Benachrichtigungen',
            description: 'Behalten Sie jederzeit den Überblick über den Einsatz Ihrer Fahrer:innen und Fahrzeuge. Lassen Sie Ausfälle sofort erkennen und lassen Sie passende Ersatzfahrer:innen zuweisen – automatisch unter Berücksichtigung von Verfügbarkeit und Qualifikation.'
          },
          item2: {
            title: 'Fahrer:innen- &<br/>Fahrzeugmanagement',
            description: 'Verwalten Sie zentrale Informationen wie Kontaktdaten, Führerscheine, Gewerkschaftszugehörigkeit, Linienpräferenzen und mehr – alles an einem Ort, intuitiv abrufbar.'
          },
          item3: {
            title: 'Dynamische Zeiterfassung &<br/>automatische Abrechnung',
            description: 'Erfassen Sie Arbeitszeiten in Echtzeit – die Gehaltsabrechnung passt sich automatisch an. Manuelle Anpassungen sind jederzeit möglich, ebenso wie die Vorschau auf künftige Einsätze und Vergütungen.'
          }
        },
        ctaButton: 'KONTAKT ANFRAGEN',
        imageAlt: 'Person arbeitet am Computer mit Kalender und Bus-Icons'
      },
      detailedFeatures: {
        title: 'Was Ihnen BusAgent Disposition bietet:',
        dailyAssignment: {
          title: 'Tägliche Zuweisung & Echtzeit-Benachrichtigungen',
          description: 'Behalten Sie jederzeit den Überblick über den Einsatz Ihrer Fahrer:innen und Fahrzeuge. Lassen Sie Ausfälle sofort erkennen und lassen Sie passende Ersatzfahrer:innen zuweisen – automatisch unter Berücksichtigung von Verfügbarkeit und Qualifikation.',
          highlight: 'Krankmeldungen werden automatisch dem bestpassenden Fahrer zugewiesen!',
          badge: {
            title: 'KRANKMELDUNG',
            status: 'NEU',
            removed: 'Max Müller',
            assigned: 'Algorithmus wählt: Lily Paulsen'
          }
        },
        management: {
          title: 'Fahrer:innen- & Fahrzeugmanagement',
          cards: {
            profiles: {
              title: 'Fahrer-Profile',
              description: 'Qualifikationen, Präferenzen und Verfügbarkeiten'
            },
            tracking: {
              title: 'Fahrzeug-Tracking',
              description: 'Echtzeit-Status aller Fahrzeuge'
            },
            matching: {
              title: 'Smart Matching',
              description: 'Optimale Fahrer-Fahrzeug-Zuweisung'
            }
          }
        },
        timeTracking: {
          title: 'Dynamische Zeiterfassung & automatische Abrechnung',
          description: 'Erfassen Sie Arbeitszeiten in Echtzeit – die Gehaltsabrechnung passt sich automatisch an. Manuelle Anpassungen sind jederzeit möglich, ebenso wie die Vorschau auf künftige Einsätze und Vergütungen.',
          highlight: 'Fahrer geben Vor- und Nachbereitungszeiten ein - alles wird automatisch in der Lohnabrechnung berücksichtigt. Am Ende nur "Berechnen" drücken!',
          dashboard: {
            title: 'Zeiterfassung Dashboard',
            workTime: 'Arbeitszeit:',
            preparation: 'Vorbereitung:',
            followUp: 'Nachbereitung:',
            total: 'Gesamt:',
            button: '→ Automatisch in Lohnabrechnung'
          }
        }
      },
      compliance: {
        title: 'Automatische Regelprüfung & Einhaltung',
        description: 'Sichern Sie die Einhaltung gesetzlicher und betrieblicher Vorgaben – mit automatisierten Validierungen und intelligenten Vorschlägen basierend auf Kosten, Qualifikation, Regeln und individuellen Präferenzen.'
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFRAGEN'
      }
    },

    // ==================== LOHNABRECHNUNG PAGE ====================
    lohnabrechnungPage: {
      hero: {
        title: 'Lohn­abrechnung auf Knopfdruck',
        subtitle: 'Kein eigenes Lohnabrechnungsprogramm mehr nötig - alles automatisch berechnet und direkt beim Steuerberater',
        ctaButton: 'KONTAKT ANFRAGEN',
        videoLabel: 'LOHNABRECHNUNG DASHBOARD'
      },
      intro: {
        title: 'Vergessen Sie komplizierte Lohnab­rechnungs­programme',
        description: 'Mit BusAgent Lohnabrechnung haben Sie alle Daten bereits im System. Arbeitszeiten, Zuschläge, Steuern - alles wird automatisch erfasst und berechnet. Ein Klick genügt und die fertige Abrechnung landet beim Steuerberater.'
      },
      process: {
        title: 'So einfach war Lohnabrechnung noch nie',
        steps: [
          {
            title: 'Datenerfassung',
            description: 'Automatische Erfassung aller Daten vom Dispositionssystem'
          },
          {
            title: 'Berechnung',
            description: 'Genaue Berechnung inkl. aller Zuschläge und Steuern'
          },
          {
            title: 'Prüfung',
            description: 'Übersichtliche Darstellung zur finalen Kontrolle'
          },
          {
            title: 'Export/Senden',
            description: 'Ein Klick - fertige Lohnabrechnung an den Steuerberater'
          }
        ]
      },
      features: {
        title: 'Alles was Sie brauchen - automatisch berechnet',
        dataCollection: {
          title: 'Vollautomatische Datenerfassung',
          description: 'Alle Arbeitszeiten werden direkt aus dem Dispositionssystem übernommen. Wer hat wann, wie lange und auf welcher Linie gefahren - alles ist bereits erfasst.',
          items: [
            'Fahrzeiten und Pausen',
            'Vor- und Nachbereitungszeiten',
            'Nachtzuschläge, Überstunden, Feiertagszuschläge, Wochenendzuschläge etc.',
            'Krankmeldungen und Urlaub',
            'Überstunden automatisch erkannt'
          ]
        }
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFRAGEN'
      }
    },

    // ==================== FAHRPERSONAL BINDEN PAGE ====================
    fahrpersonalBindenPage: {
      hero: {
        title: 'Steigern Sie die Zufriedenheit Ihres Fahrpersonals',
        subtitle: 'mit BusAgent',
        description: 'BusAgent bietet flexible Lösungen wie attraktive Dienstpläne und eine Fahrpersonal-App, um den Beruf des Busfahrenden attraktiver zu gestalten und die Kommunikation zu verbessern. So steigern Sie nachhaltig die Zufriedenheit des Fahrpersonals und die Attraktivität Ihres Unternehmens.',
        ctaButton: 'KONTAKT ANFRAGEN'
      },
      optimalSchedules: {
        title: 'Optimale Dienstpläne',
        description: 'Eine durchdachte Dienstplanung ist der Schlüssel zur Mitarbeiterzufriedenheit. Die Anforderungen Ihres Personals sind vielfältig. Insbesondere der Schichtdienst macht den Beruf des Busfahrenden herausfordernd, um Privat- und Berufsleben zu vereinbaren. Dienstpläne, die sich an das Fahrpersonal anpassen, sind daher besonders wichtig. Die automatisierte Dienstplanung von BusAgent ermöglicht es, die Bedürfnisse des Fahrpersonals in den Planungsprozess zu integrieren, um so eine bessere Work-Life-Balance zu schaffen.',
        features: {
          shiftTypes: {
            title: 'Diensttypen',
            description: 'Definieren Sie verschiedene Diensttypen und berücksichtigen Sie individuelle Präferenzen bei der Planung.'
          },
          optimization: {
            title: 'Optimierung',
            description: 'Nutzen Sie algorithmisch-gestützte Optimierung für faire und effiziente Dienstpläne, die sowohl betriebliche als auch persönliche Anforderungen erfüllen.'
          }
        },
        driverCard: {
          name: 'Sabine Fischer',
          id: 'ID: 000 000 004',
          status: 'BEREIT'
        },
        imageAlt: 'Happy Bus Driver'
      },
      features: {
        automated: {
          title: 'Automatisierte Dienstplanung',
          description: 'Reduzieren Sie den manuellen Planungsaufwand und lassen Sie BusAgent automatisch valide und optimierte Dienstpläne erstellen.'
        },
        preferences: {
          title: 'Präferenzen & Regeln',
          description: 'Nutzen Sie die Möglichkeit, eigene Präferenzen und Regeln abzubilden. Unsere Lösung unterstützt alle Arten von verschiedenen Schichtmodellen.'
        }
      },
      app: {
        title: 'Bessere Kommunikation mit der Fahrpersonal-App',
        description: 'Nicht nur bessere Dienstpläne, auch mitarbeiterfreundliche Prozesse, eine verbesserte Kommunikation und mehr Transparenz können die Zufriedenheit beim Fahrpersonal steigern. Mit der Fahrpersonal-App BusAgent stellen Sie das Fahrpersonal in den Mittelpunkt und vereinfachen den Austausch zwischen dem Fahrpersonal und der Zentrale. BusAgent bietet auch WhatsApp Benachrichtigungen und diverse Optionen über WhatsApp-Messenger an, wodurch fahrer noch schneller auf Aufgaben und Änderungen aufmerksam gemacht werden können!',
        ctaButton: 'KONTAKT ANFRAGEN',
        nav: {
          home: 'Home',
          schedule: 'Schedule',
          notification: 'Meldung',
          timesheet: 'Timesheet',
          requests: 'Requests'
        },
        whatsappAlt: 'WhatsApp',
        appFeatures: {
          scenarioPlanning: {
            title: 'Flexible Szenarienplanung',
            description: 'Mit der intuitiven Fahrpersonal-App haben die Fahrerinnen und Fahrer jederzeit Zugriff auf ihre Dienstpläne, können Schichten tauschen und erhalten wichtige Updates direkt auf ihr Smartphone.'
          },
          communication: {
            title: 'Einfache Kommunikation',
            description: 'Dank der App und der nahtlosen Integration in die Dienstplanungssoftware ist die Kommunikation zwischen Disposition und Fahrpersonal einfacher und schneller als je zuvor.'
          }
        }
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFORDERN'
      }
    },

    // ==================== FAHRGASTZUFRIEDENHEIT PAGE ====================
    fahrgastzufriedenheitPage: {
      hero: {
        title: 'Verbessern Sie das Fahrgasterlebnis',
        subtitle: 'Mit besserem Service und effektiver Kommunikation',
        description: 'Ein leistungsfähiger deutscher Verkehr beginnt mit einem reibungslosen und stressfreien Erlebnis für die Fahrgäste. BusAgent unterstützt Verkehrsunternehmen und Aufgabenträger dabei, das Angebot zu optimieren, und Pünktlichkeitsziele einzuhalten. Erleben Fahrgäste deutschlandweit den Unterschied zu un-zuverlässigem, un-verständlichem und un-komfortablem Service, nutzen sie Bus und Bahn häufiger – und empfehlen das Angebot weiter.',
        ctaButton: 'KONTAKT ANFRAGEN'
      },
      access: {
        title: 'Besserer Zugang bei gleichbleibendem Budget',
        description: 'Optimieren Sie Ihr Netz, um mehr Menschen mit dem gleichen Budget zu erreichen. Durch intelligente Planung und Analyse können Sie die Erreichbarkeit verbessern und gleichzeitig die Effizienz steigern.',
        ctaButton: 'KONTAKT ANFORDERN',
        imageAlt: 'Woman Passenger',
        features: [
          {
            title: 'Erreichbarkeit',
            description: 'BusAgent plant ihre Disposition so effizient und perfektioniert ihre Erreichbarkeit mit Anbindung zum Internet, sodass Sie mit einem Bus mehr Gäste erreichen und das pünktlich.'
          },
          {
            title: 'Schnelle Iterationen',
            description: 'Testen Sie neue Linien und Fahrpläne in Minuten statt Wochen.'
          },
          {
            title: 'Zusammenarbeit',
            description: 'Gemeinsame Planung von Routen und Fahrplänen mit allen Beteiligten.'
          }
        ]
      },
      comfort: {
        title: 'Selbst bei kurzfristigen Änderungen pünktlich sein, und das mit Plan!',
        description: 'Überfüllte Busse und Verspätungen frustrieren Fahrgäste. Mit optimaler Planung sorgen Sie für ausreichend Kapazität und pünktlichen Service.',
        ctaButton: 'KONTAKT ANFRAGEN',
        imageAlt: 'Gäste warten',
        features: [
          {
            title: 'Pünktlichkeit',
            description: 'Nutzen Sie BusAgent und optimieren Sie Fahrpläne für maximale Zuverlässigkeit.'
          },
          {
            title: 'Kapazitätsmanagement',
            description: 'Flexible Fahrzeugkapazitätsplanung basierend auf Nachfragedaten verhindert Überfüllung.'
          },
          {
            title: 'Nahtlose Zustiege',
            description: 'Optimieren Sie Verbindungen mit Zusteigern, sodass alles perfekt und nach Plan läuft.'
          }
        ]
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFORDERN'
      }
    },

    // ==================== VERKEHRSVERBUENDE PAGE ====================
    verkehrsverbuendePage: {
      hero: {
        title: 'BusAgent für\nVerkehrsverbünde &\nAufgabenträger',
        subtitle: 'Intelligente Planung für deutsche Busunternehmen',
        description: 'Optimieren Sie Ihr gesamtes Verkehrsnetz mit unserer Plattform. Lassen Sie für sich Analysieren, planen und koordinieren und somit ihre Planung effizienter und zuverlässiger gestalten.',
        ctaButton: 'KONTAKT ANFRAGEN'
      },
      efficiency: {
        title: 'Effizienz, Zuverlässigkeit und Innovation für deutsche Busunternehmen',
        description: 'BusAgent ist die modernste, Plattform im deutschsprachigen Raum, welche zu einem niedrigen Preis neuste Technologie in die Busdisposition bringt. Sie wurde speziell entwickelt, um nicht nur Verkehrsverbünde und Aufgabenträger, sondern ALLE deutschen Busunternehmer zu unterstützen. Mit BusAgent können Sie planen, optimieren, koordinieren und verwalten lassen. So gewährleisten Sie einen effizienteren und zuverlässigeren Personennahverkehr in Ihrer Region. Deutschland muss technologisch mithalten. BusAgent machts möglich. Deutsche Organisationen brauchen die technologische Infrastruktur, welche wir mit innovativen Leistungen für eine bessere deutsche Zukunft antreiben – um die Zugänglichkeit deutschen Verkehrs zu steigern und schließlich nachhaltige Fortbewegung selbstverständlich zu machen.'
      },
      functions: {
        title: 'Unsere Highlights im Überblick',
        items: [
          {
            title: 'Umlaufzeiten - und Fahrpläne',
            description: 'Erstellen und optimieren Sie umfangreiche Fahrplanungsarbeiten für die Identifizierung, Erstellung und Änderung der optimalen Fahrpläne und Umlaufzeiten. Nutzen Sie die leistungsstarken Funktionen für die Verwaltung komplexer Planungen.'
          },
          {
            title: 'Ausschreibungs- und Kontrollaufgaben',
            description: 'Verwenden Sie BusAgent zur Erstellung und Versendung Ihrer Angebote.'
          },
          {
            title: 'Reporting',
            description: 'Erhalten Sie detaillierte Berichte und nutzen Sie diese Einblicke, um kontinuierliche Verbesserungen und fundierte Entscheidungen zu treffen.'
          }
        ]
      },
      benefits: {
        title: 'Warum BusAgent?',
        items: [
          {
            title: 'Zentralisierte Planung',
            description: 'Lassen Sie Ihre Fahrpläne organisieren und optimieren. Unsere Plattform ermöglicht Ihnen eine ganzheitliche Betrachtung ihrer Organisation und verschafft Ihnen nicht nur mehr Überblick, sondern auch Zeit.'
          },
          {
            title: 'Benutzerfreundlichkeit',
            description: 'Die fortschrittliche Planung erleichtert die logische Arbeit. Die benutzerfreundliche Fahrzeugaustellung oder das Erstellen von Umlaufungen sind eine große Unterstützung.'
          },
          {
            title: 'Datengetriebene Entscheidungen',
            description: 'Lassen sie BusAgent eine umfangreiche Datenanalyse nutzen, um fundierte Entscheidungen zu treffen. BusAgent bietet Ihnen tiefergehende Einblicke, sodass Sie Trends erkennen und proaktiv auch selbst Maßnahmen ergreifen können, falls gewünscht.'
          },
          {
            title: 'Verbesserte Effizienz und Kosteneinsparungen',
            description: 'BusAgent optimiert ihre Kosten mit Hilfe der eigen entwickelten technologie. Effiziente Ressourcennutzung und optimierte Fahrpläne helfen dabei, Kosten zu senken.'
          },
          {
            title: 'Höhere Servicequalität',
            description: 'Steigern Sie die Pünktlichkeit und Zuverlässigkeit. Mit BusAgent können Sie Verspätungen im Fahrplan minimieren und somit die Fahrgastzufriedenheit steigern.'
          }
        ]
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFORDERN'
      }
    },

    // ==================== VERANSTALTUNGEN PAGE ====================
    veranstaltungenPage: {
      hero: {
        title: 'Auf folgenden Events werden wir zu finden sein!',
        subtitle: 'Wir freuen uns darauf, Sie auf einer der kommenden Veranstaltungen zu treffen!'
      },
      filters: {
        upcomingEvents: 'Kommende Veranstaltungen',
        allLocations: 'Alle Standorte',
        allEvents: 'Alle Veranstaltungen'
      },
      locations: {
        norddeutschland: 'Norddeutschland',
        ostdeutschland: 'Ostdeutschland',
        westdeutschland: 'Westdeutschland',
        mitteldeutschland: 'Mitteldeutschland',
        sueddeutschland: 'Süddeutschland'
      },
      eventTypes: {
        aktionstag: 'Aktionstag',
        jahrestagung: 'Jahrestagung',
        fachmesse: 'Fachmesse',
        kamingespraech: 'Kamingespräch',
        seminar: 'Seminar',
        bundestagung: 'Bundestagung'
      },
      pastEvents: {
        title: 'SUCHEN SIE NACH VERGANGENEN VERANSTALTUNGEN?',
        button: 'VERGANGENE EVENTS →'
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFORDERN'
      }
    },

    // ==================== VERKEHRSUNTERNEHMEN PAGE ====================
    verkehrsunternehmenPage: {
      hero: {
        title: 'BusAgent für Verkehrsunternehmen',
        subtitle: 'Optimierung und Effizienz für Ihren Busbetrieb',
        description: 'BusAgent ist die führende Plattform für die Analyse, Planung und Optimierung Ihrer Betriebsabläufe. Steigern Sie die Effizienz Ihrer Flotte und verbessern Sie gleichzeitig den Service für Ihre Fahrgäste.',
        ctaButton: 'KONTAKT ANFRAGEN'
      },
      mainContent: {
        title: 'Erhöhen Sie die Effizienz und verbessern Sie den Service mit BusAgent',
        description: 'BusAgent ist die führende Plattform, die speziell entwickelt wurde, um deutschen Verkehrsunternehmen dabei zu helfen, ihre Betriebsabläufe zu analysieren, zu planen und zu optimieren. Egal ob öffentlich oder privat, wir unterstützen Sie dabei, Ihre Flotten, das Fahrpersonal und alle weiteren Ressourcen effizient zu nutzen und gleichzeitig den Service für Ihre Fahrgäste zu verbessern.'
      },
      whyBusAgent: {
        title: 'Warum BusAgent?',
        items: [
          {
            title: 'Modernste Technologie',
            description: 'Nutzen Sie die Vorteile fortschrittlicher Algorithmen und von KI, um Fahrpläne, Umläufe und Dienste zu optimieren. Unsere Plattform ermöglicht es Ihnen, auch selbst falls gewünscht auf Veränderungen zu reagieren und Anpassungen vorzunehmen.'
          },
          {
            title: 'Kosteneinsparungen',
            description: 'Reduzieren Sie Ihre Betriebskosten durch verbesserte Planung und den effizienten Einsatz von Ressourcen. Unsere optimierte Planung senktKraftstoffverbrauch, Überstunden und den Einsatz von Fahrzeugen und Personal an Stellen, wo diese nicht benötigt werden.'
          },
          {
            title: 'Verbesserte Servicequalität',
            description: 'Bieten Sie Ihren Fahrgästen einen besseren Service. Mit BusAgent können Sie Verspätungen durch Organisationsengpässe minimieren, die Fahrgastzufriedenheit erhöhen und so die Nutzung ihres Unternehmens attraktiver gestalten.'
          },
          {
            title: 'Datengetriebene Entscheidungen',
            description: 'Lassen Sie fundierte Entscheidungen basierend auf umfangreichen Datenanalysen machen. BusAgent bietet Ihnen nicht nur detaillierte Einblicke in Ihre Betriebsabläufe, sondern kann anhand dieser für Sie die bestmögliche Entscheidungtreffen, sofern Sie dies wünschen.'
          }
        ]
      },
      features: {
        title: 'Unsere Funktionen im Überblick',
        items: [
          {
            title: 'Angebotserstellung & CRM',
            description: 'Automatisieren Sie Angebotsanfragen über Telefon, E-Mail und Website mit KI-Unterstützung. Extrahieren Sie Informationen automatisch und integrieren Sie alles nahtlos in Ihr CRM.'
          },
          {
            title: 'Disposition & Tagesbetrieb',
            description: 'Verwalten Sie tägliche Einsätze mit Echtzeit-Übersicht. Lassen Sie Ausfälle und Krankmeldungen automatisch erkennen und passende Ersatzfahrer intelligent zuweisen – unter Berücksichtigung aller Qualifikationen und Verfügbarkeiten.'
          },
          {
            title: 'Intelligente Umlauf- und Dienstplanung',
            description: 'Lassen Sie Fahrzeugumläufe und Dienste in Sekunden per KI-Algorithmus optimieren. Integrierte Planung berücksichtigt alle Regeln, Constraints und Präferenzen gleichzeitig – für bessere Ergebnisse als manuelle Arbeit.'
          },
          {
            title: 'Automatische Lohnabrechnung',
            description: 'Erfassen Sie Arbeitszeiten automatisch aus dem Dispositionssystem. Ein Knopfdruck genügt für die komplette Abrechnung mit allen Zuschlägen (Nacht, Überstunden, Urlaub). DATEV-Export direkt zum Steuerberater.'
          },
          {
            title: 'Routen- und Fahrplanoptimierung',
            description: 'Automatisieren Sie die Erstellung und Anpassung von Fahrplänen und Routen. Sparen Sie Zeit und erhöhen Sie die Genauigkeit durch intelligente Algorithmen.'
          },
          {
            title: 'Flottenmanagement',
            description: 'Optimieren Sie den Einsatz verschiedener Fahrzeugarten, verwalten Sie Ihre Busse und Einsatzzeiten effizient und reduzieren Sie Leerfahrten durch intelligente Ressourcenplanung.'
          },
          {
            title: 'Fahrerpersonal-Management & App',
            description: 'Verbessern Sie die Zufriedenheit Ihres Fahrpersonals durch optimierte Dienstpläne, eine mobile App für bessere Kommunikation und Berücksichtigung individueller Präferenzen und Qualifikationen.'
          },
          {
            title: 'Fehlermeldung & Werkstatt-Integration',
            description: 'Sekundenschnelle Schadensmeldung per QR-Code oder NFC mit automatischer Disposition bei Fahrzeugausfällen. Nahtlose Integration mit Werkstatt-Prozessen für schnelle Reaktionszeiten.'
          },
          {
            title: 'Kostensenkung & PVR-Optimierung',
            description: 'Reduzieren Sie Peak Vehicle Requirement (PVR), minimieren Sie Leerfahrten und Kraftstoffverbrauch durch intelligente Optimierung. Sparen Sie Kosten ohne Serviceeinschränkungen – messbare Einsparungen von 10-15%.'
          },
          {
            title: 'Compliance & Regelprüfung',
            description: 'Automatische Validierung gesetzlicher und betrieblicher Vorgaben mit intelligenten Vorschlägen. Lenkzeiten, Ruhezeiten und Arbeitszeitgesetze werden automatisch überwacht und eingehalten.'
          },
          {
            title: 'Szenarioplanung & Vergleichsanalysen',
            description: 'Entwickeln Sie verschiedene Planungsszenarien und vergleichen Sie diese anhand relevanter Geschäftskennzahlen. Treffen Sie fundierte Entscheidungen basierend auf konkreten Zahlen und Auswirkungen.'
          },
          {
            title: 'Analyse, Reporting & KPIs',
            description: 'Behalten Sie sämtliche Kennzahlen im Blick. Erhalten Sie umfassende Berichte und Analysen zu allen Aspekten Ihres Betriebs. Nutzen Sie diese Daten zur kontinuierlichen Optimierung Ihrer Planung.'
          }
        ]
      },
      secondaryInfo: {
        title: 'Effizienz, Zuverlässigkeit und Innovation für deutsche Busunternehmen',
        description: 'BusAgent ist die modernste, Dispositions-Plattform im deutschsprachigen Raum, welche zu einem niedrigen Preis neuste Technologie in die Busdisposition bringt. Sie wurde speziell entwickelt, um nicht nur Verkehrsverbünde und Aufgabenträger, sondern ALLE deutschen Busunternehmer zu unterstützen. Mit BusAgent können Sie planen, optimieren, koordinieren und verwalten lassen. So gewährleisten Sie einen effizienteren und zuverlässigeren Personennahverkehr in Ihrer Region. Deutschland muss technologisch mithalten. BusAgent machts möglich. Deutsche Organisationen brauchen die technologische Infrastruktur, welche wir mit innovativen Leistungen für eine bessere deutsche Zukunft antreiben – um die Zugänglichkeit deutschen Verkehrs zu steigern und schließlich nachhaltige Fortbewegung selbstverständlich zu machen.'
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFRAGEN'
      }
    },

    // ==================== UEBER UNS PAGE ====================
    ueberUnsPage: {
      hero: {
        word1: 'Deutschland',
        word2: 'gestalten',
        traffic: 'Verkehr',
        better: 'besser',
        in: 'im'
      },
      company: {
        title: 'BusAgent ist ein IT-Unternehmen, welches deutschlandweit Verkehrsunternehmen effizienter und nachhaltiger gestaltet.',
        description: 'BusAgent bietet eine integrierte Softwareplattform für Angebots-, Umlauf-, Dienst- und Turnusplanung sowie Disposition und Umlaufsplanung. Aufgabenträger, Verkehrsunternehmen und private Betreiber in Städten deutschlandweit setzen auf BusAgent, um mithilfe von sophistizierten Algorithmen, und Cloud-Computing effizientere, nachhaltigere und gerechtere Verkehrsdienste bereitzustellen.'
      },
      mission: {
        title: 'Unsere Mission',
        description: 'Eine zentrale Plattform entwickeln, die den deutschen Verkehr für Behörden, Betreiber, Fahrgäste und die Umwelt nachhaltig verbessert.'
      },
      vision: {
        title: 'Unsere Vision',
        description: 'Eine Welt gestalten, in der öffentlicher Nahverkehr überall und für alle das bevorzugte Fortbewegungsmittel ist.'
      },
      innovation: {
        title: 'Innovation deutschlandweit vorantreiben',
        buses: 'der Busse in Deutschland',
        busesUK: 'der Busse in Großbritannien',
        optimized: 'BusAgent OPTIMIERT',
        countries: 'Länder',
        cities: 'Städte werden von BusAgent versorgt',
        locations: 'Niederlassungen deutschlandweit'
      },
      culture: {
        values: {
          caring: 'Fürsorglich',
          innovative: 'Innovativ',
          determined: 'Entschlossen',
          impactful: 'Wirkungsvoll'
        },
        title: 'Unternehmenskultur und Werte',
        description: 'Die Arbeit von BusAgent hat einen großen Einfluss auf das Leben der Menschen, die Wirtschaft und unsere Städte. Unser Auftrag und unsere Vision werden von einem globalen Team talentierter, engagierter Mitarbeiter vorangetrieben, die sich an unseren Grundwerten orientieren.',
        ctaButton: 'SCHLIESSEN SIE SICH UNS AN, UM ETWAS ZU BEWIRKEN',
        ctaButtonMobile: 'Schließen sie sich uns jetzt an'
      },
      team: {
        title: 'Unsere Gründer',
        cofounderCEO: 'Mitbegründer', // und CEO
        cofounderCTO: 'Mitgründer', // und CTO
        cofounderCFO: 'Mitgründer' // und CFO
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFORDERN'
      }
    },

    // ==================== KARRIERE PAGE ====================
    karrierePage: {
      hero: {
        title: 'Werde Teil unseres Teams',
        subtitle: 'Shape the future of transportation with us'
      },
      main: {
        heading: 'Du bist ein begabter Dev mit Referenzen und genau so leidenschaftlich über Planungsoptimierung wie der Rest von uns?',
        description: 'Werde Teil unseres 7-köpfigen Teams und zeig in einem Bewerbungsgespräch nach Referenzen live, was du draufhast.',
        ctaButton: 'Jetzt bewerben',
        stats: {
          teamMembers: {
            value: '7',
            label: 'Team-Mitglieder'
          },
          remote: {
            value: '100%',
            label: 'Remote möglich'
          },
          growth: {
            value: '∞',
            label: 'Growth'
          }
        }
      },
      benefits: {
        title: 'Was wir bieten',
        items: [
          {
            title: 'Modernste Technologie',
            description: 'Arbeite mit cutting-edge Tools und Technologien an spannenden Herausforderungen'
          },
          {
            title: 'Flexibles Arbeiten',
            description: 'Remote-First Kultur mit flexiblen Arbeitszeiten und Home-Office Möglichkeiten'
          },
          {
            title: 'Persönliche Entwicklung',
            description: 'Kontinuierliche Weiterbildung und Karriereentwicklung in einem wachsenden Team'
          }
        ]
      }
    },

    // ==================== BETRIEBSKOSTEN SENKEN PAGE ====================
    betriebskostenSenkenPage: {
      hero: {
        title: 'Betriebskosten senken',
        subtitle: 'Mit intelligenterer Planung und effizientem Betrieb',
        description: 'Für Betreiber des deutschen Personennahverkehrs wird es aufgrund steigender Kraftstoff-, Arbeits- und Servicekosten immer schwieriger, wirtschaftlich zu arbeiten. BusAgent hilft Verkehrsunternehmen und Aufgabenträgern die Ausgaben zu senken, indem es die Fahrzeugnutzung optimiert und Ineffizienzen beseitigt. Von der Planung bis hin zum Betrieb wird jeder Dienst, jede Fahrt optimal genutzt, ohne dass das Angebot beeinträchtigt wird.',
        ctaButton: 'KONTAKT ANFRAGEN'
      },
      costReduction: {
        title: 'Kosten senken ohne Serviceeinschränkungen',
        description: 'Die Fahrzeugkosten sind eine der größten Ausgaben für Betreiber. Durch die Reduzierung des PVR (Peak Vehicle Requirement) können Sie erhebliche Einsparungen erzielen, ohne die Servicequalität zu beeinträchtigen.',
        diagram: {
          busAgent: 'BusAgent',
          optimization: 'Optimierung',
          savings: 'Sparen',
          pvrReduction: 'PVR Reduzierung',
          emptyRuns: 'Leerfahrten täglich',
          totalSavings: 'Einsparungen'
        }
      },
      costFeatures: {
        items: [
          {
            title: 'PVR reduzieren',
            description: 'Optimieren Sie die Routen- und Fahrplanung, um die Fahrzeugnutzung zu maximieren und die Anzahl der benötigten Fahrzeuge zu reduzieren.'
          },
          {
            title: 'Reparaturen minimieren',
            description: 'Reduzieren Sie die Wartungskosten durch intelligente Fahrzeugzuweisung und sparen sie mit jedem Kilometer nicht nur Sprit sondern auch Verschleißkosten.'
          },
          {
            title: 'Kraftstoff sparen',
            description: 'Optimieren Sie die Kraftstoffeffizienz durch intelligente Fahrzeugzuteilung und Routenoptimierung.'
          }
        ]
      },
      efficiency: {
        title: 'Effizienz von Mitarbeitern und Prozessen verbessern',
        description: 'Die Planung ändert sich ständig und der Service muss sich an neue Anforderungen anpassen. Mit BusAgent können Sie flexibel auf Änderungen reagieren und gleichzeitig die Effizienz Ihrer Mitarbeiter steigern.',
        diagram: {
          employeeA: 'Mitarbeiter A',
          shiftRequest: 'Schichtanfrage',
          busAgent: 'BusAgent',
          autoProcessing: 'Automatische Verarbeitung',
          employeeB: 'Mitarbeiter B',
          confirmation: 'Bestätigung'
        }
      },
      processFeatures: {
        items: [
          {
            title: 'Schichten ausgleichen',
            description: 'Erstellen Sie faire und effiziente Schichtpläne, die sowohl betriebliche Anforderungen als auch Mitarbeiterbedürfnisse berücksichtigen.'
          },
          {
            title: 'Tauschvorgänge automatisieren',
            description: 'Automatisieren Sie den Schichttausch zwischen Mitarbeitern und reduzieren Sie den administrativen Aufwand.'
          },
          {
            title: 'Verhindern Sie Verspätungen',
            description: 'Nutzen Sie Echtzeit-Tracking und intelligente Planung, um Verspätungen zu minimieren und die Pünktlichkeit zu verbessern.'
          },
          {
            title: 'Optimieren Sie die Lohnabrechnung',
            description: 'Automatisieren Sie die Zeiterfassung und Lohnabrechnung für genauere und schnellere Prozesse.'
          }
        ]
      },
      connectedPlatform: {
        title: 'Arbeiten Sie intelligenter mit einer vernetzten Plattform',
        description: 'Vereinheitlichen Sie Ihre Systeme und Daten auf einer Plattform. Keine isolierten Datensilos mehr - alle Informationen sind vernetzt und synchronisiert.'
      },
      finalCta: {
        title: 'Holen Sie mehr aus jedem Kilometer, jedem Dienst und jedem Euro heraus',
        subtitle: 'Mit BusAgent können Sie Kosten senken und gleichzeitig die Servicequalität verbessern. Intelligentere Planung führt zu besseren Ergebnissen.',
        question: 'Sind Sie bereit, mit weniger mehr zu erreichen? Legen wir los.',
        ctaButton: 'KONTAKT ANFRAGEN'
      },
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFRAGEN'
      }
    },

    // ==================== KONTAKT PAGE ====================
    kontaktPage: {
      hero: {
        title: 'Kontaktieren Sie Uns'
      },
      form: {
        name: 'Name',
        email: 'E-Mail',
        company: 'Unternehmensname',
        jobTitle: 'Position',
        phone: 'Telefonnummer',
        inquiry: 'Art der Anfrage',
        country: 'Land',
        organization: 'Art der Organisation',
        assistance: 'Art der Hilfe',
        message: 'Nachricht',
        required: '*',
        optional: '(optional)',
        errorRequired: 'Bitte füllen Sie dieses Pflichtfeld aus.',
        placeholders: {
          select: 'Auswählen...'
        },
        options: {
          inquiry: {
            demo: 'BusAgent-Software',
            partnership: 'Partnerschaft',
            other: 'Sonstiges'
          },
          country: {
            de: 'Deutschland',
            uk: 'Vereinigtes Königreich',
            other: 'Sonstiges'
          },
          organization: {
            transit: 'Verkehrsbetrieb',
            government: 'Behörde',
            private: 'Privater Betreiber',
            consultant: 'Berater',
            other: 'Sonstiges'
          },
          assistance: {
            all: 'Alles',
            planning: 'Routenplanung',
            scheduling: 'Fahrplanung',
            operations: 'Betrieb',
            other: 'Sonstiges'
          }
        }
      },
      submit: 'ABSENDEN',
      cta: {
        title: 'Überzeugen Sie sich selbst von der Leistungsfähigkeit von BusAgent.',
        button: 'KONTAKT ANFORDERN'
      }
    }
  },

  en: {
    // ==================== HEADER ====================
    header: {
      // Navigation
      produkte: 'Products',
      anwender: 'Users',
      unternehmen: 'Company',

      // Language
      language: 'EN',
      deutsch: 'German',
      english: 'English',

      // CTA
      ctaButton: 'REQUEST CONTACT',

      // Produkte Dropdown
      angebotserstellung: {
        title: 'Quote Creation Rental Traffic',
        description: 'Let your quote creation run fully automated for you.'
      },
      umlaufUndDienstplanung: {
        title: 'Circulation and Shift Planning',
        description: 'Intelligent planning instead of checklists. Everything in one software at the push of a button.'
      },
      disposition: {
        title: 'Dispatch',
        description: 'Modern solution for smooth operational assignment with admin and driver dashboard. Intelligent rescheduling when things don\'t go according to plan!'
      },
      fehlermeldung: {
        title: 'Error Reporting',
        description: 'Lightning-fast damage reporting via QR code or NFC - automatic dispatch included.'
      },
      lohnabrechnung: {
        title: 'Payroll',
        description: 'One click - finished payroll directly to the tax consultant. No extra software, no extra costs!'
      },

      // Anwender Dropdown
      nachAnwendern: 'BY USER TYPE',
      nachAnwendungsfall: 'BY USE CASE',

      verkehrsverbuende: {
        title: 'Transport Associations and Authorities',
        description: 'Optimize networks, increase efficiency and improve communication with passengers'
      },
      verkehrsunternehmen: {
        title: 'Transport Companies',
        description: 'Optimize vehicle usage, manage mixed fleets and reduce costs'
      },
      fahrpersonalBinden: {
        title: 'Retain Drivers',
        description: 'Increase driver satisfaction through optimized shift planning'
      },
      fahrgastzufriedenheit: {
        title: 'Passenger Satisfaction',
        description: 'Increase customer satisfaction through better service!'
      },
      betriebskostenSenken: {
        title: 'Reduce Operating Costs',
        description: 'Increase efficiency and use resources better - with improved service quality'
      },

      // Unternehmen Dropdown
      ueberUns: 'About Us',
      kontakt: 'Contact',
      career: 'Career',
      veranstaltungen: 'Events'
    },

    // ==================== HERO SECTION ====================
    hero: {
      title: 'Dispatch, automated. Planning, optimized.',
      titleMobile: 'Dispatch, automated.\nPlanning, optimized.',
      subtitle: 'For bus companies: Robust processes, better shifts, satisfied passengers. All in one platform.',
      ctaButton: 'REQUEST CONTACT',
      imageAlt: 'Bus driver greeting a passenger'
    },

    // ==================== STATS SECTION ====================
    stats: {
      cities: 'Cities',
      tripsNumber: '350,000',
      trips: 'Trips per Year',
      savingsNumber: '4.5 Million',
      savings: 'Euros Saved'
    },

    // ==================== PLATFORM SECTION ====================
    platform: {
      mainTitle: 'Smart planning at the push of a button.',
      mainSubtitle: 'Clear, User-Friendly, Efficient',
      highlights: 'The Highlights of BusAgent',
      ctaButton: 'LEARN MORE',

      // Tabs
      tabs: {
        plattform: {
          label: 'Platform',
          title: 'Platform',
          description: 'Our platform offers not only everything your existing dispatch program can do, but much more. BusAgent delivers results with significant labor savings. Our efficient algorithm not only delivers equally good results, but even better results than human workers!'
        },
        angebotsplanung: {
          label: 'Quote Planning',
          title: 'Quote Planning',
          description: 'Bus operators know it: A request comes in, you may have to process it again with an additional program and then send the customer a quote. BusAgent uses AI to optimize your quote planning at the push of a button.'
        },
        umlaufDienstplanung: {
          label: 'Circulation & Shift Planning',
          title: 'Circulation and Shift Planning',
          description: 'Let vehicle circulations and shifts be planned efficiently for you. Planning is done at the push of a button and fully automated via the BusAgent algorithm. Save not only costs in dispatch, but through dispatch. Let the software work for you and not the other way around!'
        }
      }
    },

    // ==================== SOLUTIONS SECTION ====================
    solutions: {
      title: 'Whether public or private, large or small –',
      titleBreak: 'BusAgent has a solution for everything.',
      loadingText: 'Loading animations...',

      items: {
        agencies: 'Transport Authorities',
        cities: 'Cities',
        operators: 'Transport Companies',
        events: 'Events',
        corporations: 'Corporations',
        consultancies: 'Consulting Firms',
        universities: 'Universities'
      }
    },

    // ==================== CUSTOMERS SECTION ====================
    customers: {
      title: 'Our Customers',
      prevQuote: 'Previous quote',
      nextQuote: 'Next quote',
      quoteNumber: 'Quote',

      quotes: [
        {
          text: 'Was actually one of the first customers. Back then there were only three of them, and now I have my own account manager. Very satisfied with support and the custom adjustments I wanted. Got it for shift and circulation planning and BusAgent really delivers incredible results! Very positively surprised!',
          author: 'Wolfgang Mularzyk',
          position: 'Digitalization Project Manager, HADAG'
        },
        {
          text: 'Actually didn\'t feel like "switching" to new software at first. But since BusAgent has manual features similar to the old software anyway, it wasn\'t a problem. My dispatchers hardly use the manual features anymore anyway, since you only have to press one button!',
          author: 'Maria Schmidt',
          position: 'Head of Traffic Planning, Munich Transport'
        },
        {
          text: 'Had 4 dispatchers before... Turned out I don\'t need all 4 in dispatch after all. Now I actually have around 9,000-11,000 euros more to spend elsewhere than in dispatch. Very happy I did this!',
          author: 'Thomas Weber',
          position: 'CEO, Regional Transport North GmbH'
        },
        {
          text: 'Operating the software is incredibly easy. Used to do everything myself and now so much work is taken off my hands, really great stuff!',
          author: 'Julia Becker',
          position: 'Operations Manager, Frankfurt Transport'
        },
        {
          text: 'I\'m a bit of a techie myself here, and I\'m really impressed. I don\'t have access to the source code, but you really have to be skilled to develop something like this!',
          author: 'Michael Hoffmann',
          position: 'IT Director, Berlin Transport'
        },
        {
          text: 'I don\'t have the exact numbers, but sometimes I really had to pay fines just because my dispatcher was too incompetent to plan driving times correctly. With BusAgent this not only hasn\'t happened anymore, but I\'m extremely sure we have SIGNIFICANTLY lower fuel costs... More money left over at the end of the month for me :)',
          author: 'Sandra Meyer',
          position: 'Sustainability Officer, Rhine-Ruhr Transport'
        }
      ]
    },

    // ==================== HIRING CTA SECTION ====================
    hiringCTA: {
      title: 'We have big plans and want to make bus companies better together!',
      subtitle: 'Do you want to make a difference?',
      ctaButton: 'JOIN US',
      imageAlt: 'Team sitting together and laughing'
    },

    // ==================== DEMO CTA SECTION ====================
    demoCTA: {
      title: 'See for yourself the',
      titleHighlight: 'performance of BusAgent.',
      ctaButton: 'REQUEST CONTACT'
    },

    // ==================== FOOTER ====================
    footer: {
      produkte: {
        title: 'Products',
        angebotserstellung: 'Quote Creation',
        umlaufDienstplanung: 'Circulation & Shift Planning',
        disposition: 'Dispatch',
        fehlermeldung: 'Error Reporting',
        lohnabrechnung: 'Payroll',
        fuerArztpraxen: 'FOR MEDICAL PRACTICES',
        diktieragent: 'DiktierAgent'
      },
      anwender: {
        title: 'Users',
        nachAnwendern: 'BY USER TYPE',
        verkehrsunternehmen: 'Transport Companies',
        verkehrsverbuende: 'Transport Associations',
        nachAnwendungsfall: 'BY USE CASE',
        fahrpersonalBinden: 'Driver Retention',
        fahrgastzufriedenheit: 'Passenger Satisfaction',
        betriebskostenSenken: 'Reduce Operating Costs'
      },
      unternehmen: {
        title: 'Company',
        ueberUns: 'About Us',
        career: 'Career',
        kontakt: 'Contact',
        veranstaltungen: 'Events'
      },
      legal: {
        title: 'Legal',
        impressum: 'Imprint',
        datenschutz: 'Privacy Policy',
        nutzungsbedingungen: 'Terms of Use'
      },
      ctaButton: 'REQUEST CONTACT'
    },

    // ==================== ANGEBOTSERSTELLUNG PAGE ====================
    angebotserstellungPage: {
      hero: {
        title: 'Quote Creation Fully Automated',
        subtitle: 'No more manual processes! BusAgent revolutionizes your quote creation across all channels - phone, email, and website - with intelligent AI support.',
        ctaPrimary: 'REQUEST CONTACT',
        ctaSecondary: 'LEARN MORE',
        channels: {
          phone: {
            title: 'Phone',
            description: 'AI extracts info from conversations'
          },
          email: {
            title: 'Email',
            description: 'LLM reads and processes requests'
          },
          website: {
            title: 'Website',
            description: 'Direct CRM integration'
          }
        }
      },
      problem: {
        title: 'The Problem: Manual Quote Creation Costs Time and Money',
        subtitle: 'Many companies still work with outdated processes - requests via email, phone, or forms are processed manually. This leads to delays, errors, and missed opportunities.',
        challenges: {
          timeConsuming: {
            title: 'Time-Consuming',
            description: 'Manual data entry and processing of every single request'
          },
          errorProne: {
            title: 'Error-Prone',
            description: 'High probability of Transfer errors and inconsistent quotes'
          },
          noIntegration: {
            title: 'No Integration',
            description: 'Isolated systems without connection to quote software'
          }
        }
      },
      solution: {
        title: 'The Solution: BusAgent Automates All Channels',
        subtitle: 'A CRM system integrated into BusAgent that automatically captures, processes, and transforms all requests into professional quotes.',
        website: {
          title: 'Website Forms',
          description: 'Your existing website forms are directly connected to the BusAgent CRM, or newly created if not available. Every request automatically lands in the system and is processed immediately.',
          benefits: {
            integration: 'Seamless integration into existing forms',
            transfer: 'Automatic data transfer to CRM',
            instant: 'Instant quote proposals'
          },
          form: {
            company: 'Company',
            companyPlaceholder: 'Transport Ltd',
            departure: 'Departure Location',
            departurePlaceholder: 'London',
            arrival: 'Arrival Location',
            arrivalPlaceholder: 'Birmingham',
            setDeparture: 'Set Departure',
            setArrival: 'Set Arrival',
            departureDate: 'Departure Date',
            arrivalDate: 'Arrival Date',
            departureTime: 'Departure Time',
            arrivalTime: 'Arrival Time',
            passengers: 'Number of Passengers',
            passengersPlaceholder: '50',
            submit: 'Request Quote',
            crmNote: '→ Directly to BusAgent CRM'
          }
        },
        phone: {
          title: 'Phone with AI Assistant',
          description: 'BusAgent AI automatically recognizes quote requests during phone calls and extracts all relevant information in real-time.',
          benefits: {
            recognition: 'Automatic recognition of quote requests',
            extraction: 'Intelligent data extraction from conversations',
            confirmation: 'Confirmation before CRM transfer'
          },
          demo: {
            incoming: 'Incoming Call',
            aiActive: 'AI Assistant Active',
            step1: '1. "I recognize your quote request..."',
            step2: '2. Extract: Route, timeframe...',
            step3: '3. Transfer data to CRM'
          }
        },
        email: {
          title: 'Email with LLM Processing',
          description: 'Our advanced Language Model reads and understands incoming emails, extracts all relevant information, and creates structured datasets.',
          benefits: {
            understanding: 'Intelligent text understanding',
            categorization: 'Automatic categorization',
            structured: 'Structured data capture'
          },
          demo: {
            from: 'From: customer@example.com',
            subject: 'Subject: Bus Connection Inquiry',
            content: '"We need a quote for a connection between..."',
            extraction: 'LLM Extraction:',
            route: '✓ Route: A → B',
            time: '✓ Departure Time: 09:00 AM',
            passengers: '✓ Passengers: 73'
          }
        }
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== UMLAUF UND DIENSTPLANUNG PAGE ====================
    umlaufPage: {
      hero: {
        title: 'Intelligent Dispatch Instead of Checklists',
        subtitle: 'BusAgent thinks ahead: Automatic assignment through smart algorithms instead of manual processing of lists. Save time, money, and resources.',
        ctaPrimary: 'REQUEST CONTACT',
        ctaSecondary: 'LEARN MORE',
        videoLabel: 'INTELLIGENT DISPATCH'
      },
      evolution: {
        title: 'From Paper to Intelligence: The Evolution of Dispatch',
        paperBased: {
          title: 'Paper-Based',
          description: 'Manual lists, illegible notes, lost papers',
          cons: {
            timeConsuming: 'Time-Consuming',
            errorProne: 'Error-Prone',
            noOverview: 'No Overview',
            inefficient: 'Inefficient'
          }
        },
        traditional: {
          title: 'Traditional Software',
          description: 'Digital lists showing what still needs to be done',
          pros: {
            digital: 'Digitally recorded'
          },
          cons: {
            manual: 'Manual assignment',
            noOptimization: 'No optimization'
          }
        },
        busAgent: {
          title: 'BusAgent',
          description: 'Algorithm thinks ahead and assigns automatically',
          pros: {
            automatic: 'Automatic assignment',
            optimization: 'Algorithmic optimization',
            savings: 'Save resources'
          }
        }
      },
      difference: {
        title: 'The Decisive Difference: Thinking Ahead Instead of Checking Off',
        traditional: {
          title: 'Traditional Software',
          intro: 'Existing solutions work like digital checklists:',
          points: {
            showTodo: 'Only show what needs to be done',
            manual: 'Manual assignment required',
            check: 'Only check afterwards',
            noOptimization: 'No intelligent optimization'
          },
          quote: 'You still work through the list - just digitally.'
        },
        busAgent: {
          title: 'BusAgent',
          intro: 'BusAgent actively thinks ahead and takes over the work:',
          points: {
            automated: 'Completes tasks at the push of a button',
            automatic: 'Automatic algorithmic assignment',
            realtime: 'Optimizes in real-time',
            savings: 'Saves resources and money'
          },
          quote: 'The software works for you - not the other way around.'
        }
      },
      features: {
        speed: {
          title: 'Circulation and Shift Planning at Maximum Speed',
          description: 'Optimization of shifts and vehicles takes seconds to minutes, not hours or days. This allows you to test multiple scenarios and select the best result. Our technology not only accelerates the entire planning process but also enables you to verify the impact based on constantly updated business metrics.'
        },
        quality: {
          title: 'Circulation Planning Software That Delivers High-Quality Results',
          description: 'Consideration of all rules and constraints such as relief vehicles, vehicle types, and driving times guarantees that the resulting circulation plans are of high quality. This in turn has a direct impact on shift planning.'
        },
        integration: {
          title: 'Integrated Circulation and Shift Plan Optimization',
          description: 'The ability to optimize vehicles and shifts (including relief vehicles) simultaneously enables special added value. This allows vehicle circulations to be created while improving shift plans or vice versa. This ensures optimal resource utilization. By integrating relief vehicles into the system, optimized vehicle and shift plans are created in less time and at lower costs. In integrated optimization, all parameters are considered and improved together, enabling time savings, error prevention, and cost reduction.'
        }
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== FEHLERMELDUNG PAGE ====================
    fehlermeldungPage: {
      hero: {
        title: 'Error Reporting in Seconds',
        subtitle: 'From damage report to automatic dispatch - everything with one scan',
        ctaButton: 'REQUEST DEMO',
        imageAlt: 'Error Reporting System'
      },
      process: {
        title: 'How it works - Simple as that',
        steps: [
          {
            number: '1',
            title: 'Installation',
            description: 'Our technician installs QR codes or NFC chips in every vehicle'
          },
          {
            number: '2',
            title: 'Reporting',
            description: 'Driver scans code/chip and reports damage in seconds'
          },
          {
            number: '3',
            title: 'Dispatch',
            description: 'Vehicle is automatically marked as unavailable'
          },
          {
            number: '4',
            title: 'Repair',
            description: 'After repair: One scan is enough to release the vehicle'
          }
        ]
      },
      details: {
        title: 'The Complete Process in Detail',
        step1: {
          title: 'Free Installation',
          description: 'A BusAgent technician comes to you and installs a QR code or NFC chip in every vehicle. This setup is fully included in the software price - no additional costs!',
          benefits: {
            professional: 'Professional on-site installation',
            technology: 'Choice of QR code or NFC technology',
            noCost: 'No additional costs'
          },
          imageLabel: 'QR Code & NFC Chips'
        },
        step2: {
          title: 'Lightning-Fast Damage Reporting',
          description: 'The bus driver discovers damage? A quick scan of the QR code or NFC chip is enough. An online form opens automatically - no app installation needed!',
          process: {
            scan: 'Scan code/chip',
            photo: 'Upload photo of damage (optional)',
            description: 'Add brief description',
            submit: 'Submit - done!'
          },
          imageLabel: 'Photo Upload in Seconds'
        },
        step3: {
          title: 'Automatic Dispatch',
          description: 'As soon as the report comes in, everything happens automatically: The vehicle is marked as unavailable in the dispatch system and the intelligent algorithm no longer schedules it.',
          status: {
            blocked: 'Vehicle blocked',
            notified: 'Workshop notified'
          },
          optimizationLabel: 'Algorithmically optimized dispatch'
        },
        step4: {
          title: 'Easy Release',
          description: 'After repair, another scan in the workshop or a click in the dashboard is enough. The vehicle is immediately available for dispatch again.',
          methods: {
            scan: 'Scan in workshop',
            or: 'or',
            dashboard: 'Click in dashboard'
          }
        }
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== DISPOSITION PAGE ====================
    dispositionPage: {
      hero: {
        title: 'BusAgent Dispatch',
        subtitle: 'The modern solution for smooth operational assignment – today and in the future',
        ctaButton: 'REQUEST CONTACT',
        videoLabel: 'LIVE DISPATCH'
      },
      intro: {
        title: 'Your buses and drivers work in real-time – now your dispatch software does too.',
        paragraphs: {
          p1: 'With BusAgent Dispatch, we present the first operational assignment system that thinks along with your operations in real-time.',
          p2: 'The solution was developed from scratch together with transport companies – based on real requirements, intensive testing, and practical feedback. The result: A tailor-made, future-proof solution that truly solves your operational challenges.',
          p3: 'BusAgent Dispatch continuously evolves – so you\'re prepared today for tomorrow\'s requirements.'
        }
      },
      features: {
        title: 'What BusAgent Dispatch offers you:',
        accordion: {
          item1: {
            title: 'Daily Assignment &<br/>Real-Time Notifications',
            description: 'Keep track of your drivers and vehicles at all times. Have absences detected immediately and have suitable replacement drivers assigned – automatically considering availability and qualifications.'
          },
          item2: {
            title: 'Driver &<br/>Vehicle Management',
            description: 'Manage central information such as contact details, licenses, union membership, route preferences and more – all in one place, intuitively accessible.'
          },
          item3: {
            title: 'Dynamic Time Tracking &<br/>Automatic Billing',
            description: 'Record working hours in real-time – payroll adjusts automatically. Manual adjustments are possible at any time, as well as previews of future assignments and compensation.'
          }
        },
        ctaButton: 'REQUEST CONTACT',
        imageAlt: 'Person working at computer with calendar and bus icons'
      },
      detailedFeatures: {
        title: 'What BusAgent Dispatch offers you:',
        dailyAssignment: {
          title: 'Daily Assignment & Real-Time Notifications',
          description: 'Keep track of your drivers and vehicles at all times. Have absences detected immediately and have suitable replacement drivers assigned – automatically considering availability and qualifications.',
          highlight: 'Sick leave reports are automatically assigned to the best-matching driver!',
          badge: {
            title: 'SICK LEAVE',
            status: 'NEW',
            removed: 'Max Müller',
            assigned: 'Algorithm chooses: Lily Paulsen'
          }
        },
        management: {
          title: 'Driver & Vehicle Management',
          cards: {
            profiles: {
              title: 'Driver Profiles',
              description: 'Qualifications, preferences and availabilities'
            },
            tracking: {
              title: 'Vehicle Tracking',
              description: 'Real-time status of all vehicles'
            },
            matching: {
              title: 'Smart Matching',
              description: 'Optimal driver-vehicle assignment'
            }
          }
        },
        timeTracking: {
          title: 'Dynamic Time Tracking & Automatic Billing',
          description: 'Record working hours in real-time – payroll adjusts automatically. Manual adjustments are possible at any time, as well as previews of future assignments and compensation.',
          highlight: 'Drivers enter preparation and follow-up times - everything is automatically included in payroll. Just press "Calculate" at the end!',
          dashboard: {
            title: 'Time Tracking Dashboard',
            workTime: 'Work time:',
            preparation: 'Preparation:',
            followUp: 'Follow-up:',
            total: 'Total:',
            button: '→ Automatically to payroll'
          }
        }
      },
      compliance: {
        title: 'Automatic Rule Checking & Compliance',
        description: 'Ensure compliance with legal and operational requirements – with automated validations and intelligent suggestions based on cost, qualifications, rules and individual preferences.'
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== FAHRPERSONAL BINDEN PAGE ====================
    fahrpersonalBindenPage: {
      hero: {
        title: 'Increase Driver Satisfaction',
        subtitle: 'with BusAgent',
        description: 'BusAgent offers flexible solutions such as attractive shift plans and a driver app to make the bus driver profession more attractive and improve communication. This sustainably increases driver satisfaction and the attractiveness of your company.',
        ctaButton: 'REQUEST CONTACT'
      },
      optimalSchedules: {
        title: 'Optimal Shift Plans',
        description: 'Well-thought-out shift planning is the key to employee satisfaction. The requirements of your staff are diverse. Shift work in particular makes it challenging for bus drivers to reconcile private and professional life. Shift plans that adapt to the drivers are therefore particularly important. BusAgent\'s automated shift planning makes it possible to integrate the needs of the driving staff into the planning process, thus creating a better work-life balance.',
        features: {
          shiftTypes: {
            title: 'Shift Types',
            description: 'Define different shift types and consider individual preferences when planning.'
          },
          optimization: {
            title: 'Optimization',
            description: 'Use algorithm-supported optimization for fair and efficient shift plans that meet both operational and personal requirements.'
          }
        },
        driverCard: {
          name: 'Sabine Fischer',
          id: 'ID: 000 000 004',
          status: 'READY'
        },
        imageAlt: 'Happy Bus Driver'
      },
      features: {
        automated: {
          title: 'Automated Shift Planning',
          description: 'Reduce manual planning effort and let BusAgent automatically create valid and optimized shift plans.'
        },
        preferences: {
          title: 'Preferences & Rules',
          description: 'Use the possibility to map your own preferences and rules. Our solution supports all types of different shift models.'
        }
      },
      app: {
        title: 'Better Communication with the Driver App',
        description: 'Not only better shift plans, but also employee-friendly processes, improved communication and more transparency can increase driver satisfaction. With the BusAgent driver app, you put the drivers at the center and simplify the exchange between drivers and headquarters. BusAgent also offers WhatsApp notifications and various options via WhatsApp messenger, allowing drivers to be notified even faster about tasks and changes!',
        ctaButton: 'REQUEST CONTACT',
        nav: {
          home: 'Home',
          schedule: 'Schedule',
          notification: 'Report',
          timesheet: 'Timesheet',
          requests: 'Requests'
        },
        whatsappAlt: 'WhatsApp',
        appFeatures: {
          scenarioPlanning: {
            title: 'Flexible Scenario Planning',
            description: 'With the intuitive driver app, drivers have access to their shift plans at any time, can swap shifts and receive important updates directly on their smartphone.'
          },
          communication: {
            title: 'Easy Communication',
            description: 'Thanks to the app and seamless integration into the shift planning software, communication between dispatch and drivers is easier and faster than ever before.'
          }
        }
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== FAHRGASTZUFRIEDENHEIT PAGE ====================
    fahrgastzufriedenheitPage: {
      hero: {
        title: 'Improve the Passenger Experience',
        subtitle: 'With better service and effective communication',
        description: 'Efficient transport begins with a smooth and stress-free experience for passengers. BusAgent supports transport companies and authorities in optimizing services and meeting punctuality goals. When passengers nationwide experience the difference from unreliable, incomprehensible and uncomfortable service, they use buses and trains more often – and recommend the service.',
        ctaButton: 'REQUEST CONTACT'
      },
      access: {
        title: 'Better Access with the Same Budget',
        description: 'Optimize your network to reach more people with the same budget. Through intelligent planning and analysis, you can improve accessibility while increasing efficiency.',
        ctaButton: 'REQUEST CONTACT',
        imageAlt: 'Woman Passenger',
        features: [
          {
            title: 'Accessibility',
            description: 'BusAgent plans your dispatch so efficiently and perfects your accessibility with internet connection, so you reach more passengers with one bus - and on time.'
          },
          {
            title: 'Fast Iterations',
            description: 'Test new routes and schedules in minutes instead of weeks.'
          },
          {
            title: 'Collaboration',
            description: 'Joint planning of routes and schedules with all stakeholders.'
          }
        ]
      },
      comfort: {
        title: 'Be on time even with short-term changes, and according to plan!',
        description: 'Overcrowded buses and delays frustrate passengers. With optimal planning, you ensure sufficient capacity and punctual service.',
        ctaButton: 'REQUEST CONTACT',
        imageAlt: 'Passengers waiting',
        features: [
          {
            title: 'Punctuality',
            description: 'Use BusAgent and optimize schedules for maximum reliability.'
          },
          {
            title: 'Capacity Management',
            description: 'Flexible vehicle capacity planning based on demand data prevents overcrowding.'
          },
          {
            title: 'Seamless Connections',
            description: 'Optimize connections with transfers so everything runs perfectly and according to plan.'
          }
        ]
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== LOHNABRECHNUNG PAGE ====================
    lohnabrechnungPage: {
      hero: {
        title: 'Payroll at the Push of a Button',
        subtitle: 'No separate payroll software needed - everything calculated automatically and sent directly to the tax consultant',
        ctaButton: 'REQUEST CONTACT',
        videoLabel: 'PAYROLL DASHBOARD'
      },
      intro: {
        title: 'Forget Complicated Payroll Programs',
        description: 'With BusAgent Payroll, you already have all data in the system. Working hours, allowances, taxes - everything is captured and calculated automatically. One click is enough and the finished payroll goes to the tax consultant.'
      },
      process: {
        title: 'Payroll Has Never Been This Easy',
        steps: [
          {
            title: 'Data Collection',
            description: 'Automatic capture of all data from the dispatch system'
          },
          {
            title: 'Calculation',
            description: 'Precise calculation including all allowances and taxes'
          },
          {
            title: 'Review',
            description: 'Clear presentation for final control'
          },
          {
            title: 'Export/Send',
            description: 'One click - finished payroll to the tax consultant'
          }
        ]
      },
      features: {
        title: 'Everything You Need - Automatically Calculated',
        dataCollection: {
          title: 'Fully Automatic Data Collection',
          description: 'All working hours are taken directly from the dispatch system. Who drove when, how long, and on which route - everything is already recorded.',
          items: [
            'Driving times and breaks',
            'Preparation and follow-up times',
            'Night allowances, overtime, holiday allowances, weekend allowances, etc.',
            'Sick leave and vacation',
            'Overtime automatically recognized'
          ]
        }
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== VERKEHRSVERBUENDE PAGE ====================
    verkehrsverbuendePage: {
      hero: {
        title: 'BusAgent for\nTransport Associations &\nAuthorities',
        subtitle: 'Intelligent planning for bus companies',
        description: 'Optimize your entire transport network with our platform. Let us analyze, plan and coordinate for you, making your planning more efficient and reliable.',
        ctaButton: 'REQUEST CONTACT'
      },
      efficiency: {
        title: 'Efficiency, Reliability and Innovation for Bus Companies',
        description: 'BusAgent is the most modern platform in the German-Region, bringing the latest technology to bus dispatch at a low price. It was specifically developed to support not only transport associations and authorities, but ALL bus operators. With BusAgent, you can have planning, optimization, coordination and management done for you. This ensures more efficient and reliable local public transport in your region. Europe must keep up technologically. BusAgent makes it possible. Western organizations need the technological infrastructure that we drive forward with innovative services for a better future – to increase the accessibility of transport and ultimately make sustainable mobility a matter of course.'
      },
      functions: {
        title: 'Our Highlights at a Glance',
        items: [
          {
            title: 'Circulation Times and Schedules',
            description: 'Create and optimize extensive scheduling work for identifying, creating and modifying optimal schedules and circulation times. Use the powerful features for managing complex planning.'
          },
          {
            title: 'Tender and Control Tasks',
            description: 'Use BusAgent to create and send your quotes.'
          },
          {
            title: 'Reporting',
            description: 'Receive detailed reports and use these insights to make continuous improvements and informed decisions.'
          }
        ]
      },
      benefits: {
        title: 'Why BusAgent?',
        items: [
          {
            title: 'Centralized Planning',
            description: 'Have your schedules organized and optimized. Our platform enables you to take a holistic view of your organization, giving you not only more overview, but also time.'
          },
          {
            title: 'User-Friendliness',
            description: 'Advanced planning facilitates logical work. User-friendly vehicle selection and the creation of circulations are a great support.'
          },
          {
            title: 'Data-Driven Decisions',
            description: 'Let BusAgent use comprehensive data analysis to make informed decisions. BusAgent offers you deeper insights so that you can identify trends and proactively take action yourself if desired.'
          },
          {
            title: 'Improved Efficiency and Cost Savings',
            description: 'BusAgent optimizes your costs with the help of proprietary technology. Efficient resource use and optimized schedules help reduce costs.'
          },
          {
            title: 'Higher Service Quality',
            description: 'Increase punctuality and reliability. With BusAgent, you can minimize delays in the schedule and thus increase passenger satisfaction.'
          }
        ]
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== VERANSTALTUNGEN PAGE ====================
    veranstaltungenPage: {
      hero: {
        title: 'Find us at the following events!',
        subtitle: 'We look forward to meeting you at one of the upcoming events!'
      },
      filters: {
        upcomingEvents: 'Upcoming Events',
        allLocations: 'All Locations',
        allEvents: 'All Events'
      },
      locations: {
        norddeutschland: 'Northern Germany',
        ostdeutschland: 'Eastern Germany',
        westdeutschland: 'Western Germany',
        mitteldeutschland: 'Central Germany',
        sueddeutschland: 'Southern Germany'
      },
      eventTypes: {
        aktionstag: 'Action Day',
        jahrestagung: 'Annual Conference',
        fachmesse: 'Trade Fair',
        kamingespraech: 'Fireside Chat',
        seminar: 'Seminar',
        bundestagung: 'Federal Conference'
      },
      pastEvents: {
        title: 'LOOKING FOR PAST EVENTS?',
        button: 'PAST EVENTS →'
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== VERKEHRSUNTERNEHMEN PAGE ====================
    verkehrsunternehmenPage: {
      hero: {
        title: 'BusAgent for Transport Companies',
        subtitle: 'Optimization and Efficiency for Your Bus Operation',
        description: 'BusAgent is the leading platform for analyzing, planning and optimizing your operations. Increase the efficiency of your fleet while improving service for your passengers.',
        ctaButton: 'REQUEST CONTACT'
      },
      mainContent: {
        title: 'Increase Efficiency and Improve Service with BusAgent',
        description: 'BusAgent is the leading platform specifically developed to help transport companies analyze, plan and optimize their operations. Whether public or private, we support you in efficiently using your fleets, driving staff and all other resources while improving service for your passengers.'
      },
      whyBusAgent: {
        title: 'Why BusAgent?',
        items: [
          {
            title: 'State-of-the-Art Technology',
            description: 'Benefit from advanced algorithms and AI to optimize schedules, circulations and shifts. Our platform enables you to respond to changes yourself and make adjustments if desired.'
          },
          {
            title: 'Cost Savings',
            description: 'Reduce your operating costs through improved planning and efficient use of resources. Our optimized planning reduces fuel consumption, overtime and the deployment of vehicles and personnel where they are not needed.'
          },
          {
            title: 'Improved Service Quality',
            description: 'Offer your passengers better service. With BusAgent you can minimize delays due to organizational bottlenecks, increase passenger satisfaction and make using your company more attractive.'
          },
          {
            title: 'Data-Driven Decisions',
            description: 'Let informed decisions be made based on comprehensive data analysis. BusAgent not only offers you detailed insights into your operations, but can make the best possible decision for you based on this, if you wish.'
          }
        ]
      },
      features: {
        title: 'Our Features at a Glance',
        items: [
          {
            title: 'Quote Creation & CRM',
            description: 'Automate quote requests via phone, email and website with AI support. Extract information automatically and integrate everything seamlessly into your CRM.'
          },
          {
            title: 'Dispatch & Daily Operations',
            description: 'Manage daily assignments with real-time overview. Have absences and sick leave automatically detected and suitable replacement drivers intelligently assigned – considering all qualifications and availabilities.'
          },
          {
            title: 'Intelligent Circulation and Shift Planning',
            description: 'Have vehicle circulations and shifts optimized in seconds via AI algorithm. Integrated planning considers all rules, constraints and preferences simultaneously – for better results than manual work.'
          },
          {
            title: 'Automatic Payroll',
            description: 'Capture working hours automatically from the dispatch system. One click is enough for complete billing with all allowances (night, overtime, vacation). DATEV export directly to tax consultant.'
          },
          {
            title: 'Route and Schedule Optimization',
            description: 'Automate the creation and adjustment of schedules and routes. Save time and increase accuracy through intelligent algorithms.'
          },
          {
            title: 'Fleet Management',
            description: 'Optimize the use of different vehicle types, manage your buses and deployment times efficiently and reduce empty runs through intelligent resource planning.'
          },
          {
            title: 'Driver Management & App',
            description: 'Improve driver satisfaction through optimized shift plans, a mobile app for better communication and consideration of individual preferences and qualifications.'
          },
          {
            title: 'Error Reporting & Workshop Integration',
            description: 'Lightning-fast damage reporting via QR code or NFC with automatic dispatch for vehicle breakdowns. Seamless integration with workshop processes for fast response times.'
          },
          {
            title: 'Cost Reduction & PVR Optimization',
            description: 'Reduce Peak Vehicle Requirement (PVR), minimize empty runs and fuel consumption through intelligent optimization. Save costs without service restrictions – measurable savings of 10-15%.'
          },
          {
            title: 'Compliance & Rule Checking',
            description: 'Automatic validation of legal and operational requirements with intelligent suggestions. Driving times, rest periods and working time laws are automatically monitored and complied with.'
          },
          {
            title: 'Scenario Planning & Comparative Analysis',
            description: 'Develop different planning scenarios and compare them based on relevant business metrics. Make informed decisions based on concrete numbers and impacts.'
          },
          {
            title: 'Analysis, Reporting & KPIs',
            description: 'Keep track of all metrics. Receive comprehensive reports and analyses on all aspects of your operations. Use this data for continuous optimization of your planning.'
          }
        ]
      },
      secondaryInfo: {
        title: 'Efficiency, Reliability and Innovation for Bus Companies',
        description: 'BusAgent is the most modern dispatch platform in the German-speaking region, bringing the latest technology to bus dispatch at a low price. It was specifically developed to support not only transport associations and authorities, but ALL bus operators. With BusAgent, you can have planning, optimization, coordination and management done for you. This ensures more efficient and reliable local public transport in your region. Europe must keep up technologically. BusAgent makes it possible. Western organizations need the technological infrastructure that we drive forward with innovative services for a better future – to increase the accessibility of transport and ultimately make sustainable mobility a matter of course.'
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== UEBER UNS PAGE ====================
    ueberUnsPage: {
      hero: {
        word1: 'Build ',
        word2: 'together',
        traffic: 'better',
        better: 'transport',
        in: 'for'
      },
      company: {
        title: 'BusAgent is an IT company that makes transport companies across western Europe more efficient and sustainable.',
        description: 'BusAgent offers an integrated software platform for quotation, circulation, shift and roster planning as well as dispatch and circulation planning. Transport authorities, transport companies and private operators in cities across Europe rely on BusAgent to provide more efficient, sustainable and fairer transport services using sophisticated algorithms and cloud computing.'
      },
      mission: {
        title: 'Our Mission',
        description: 'Develop a central platform that sustainably improves transportation for authorities, operators, passengers and the environment.'
      },
      vision: {
        title: 'Our Vision',
        description: 'Create a world where public transport is the preferred means of transport everywhere and for everyone.'
      },
      innovation: {
        title: 'Driving innovation across Germany',
        buses: 'of all driving omni-buses in Germany',
        busesUK: 'of all driving omni-buses in the UK',
        optimized: 'BusAgent OPTIMIZES',
        countries: 'Countries',
        cities: 'Cities served by BusAgent',
        locations: 'Locations across Germany'
      },
      culture: {
        values: {
          caring: 'Caring',
          innovative: 'Innovative',
          determined: 'Determined',
          impactful: 'Impactful'
        },
        title: 'Company Culture and Values',
        description: 'BusAgent\'s work has a major impact on people\'s lives, the economy and our cities. Our mission and vision are driven by a global team of talented, dedicated employees who are guided by our core values.',
        ctaButton: 'JOIN US TO MAKE AN IMPACT',
        ctaButtonMobile: 'Join us now'
      },
      team: {
        title: 'Our Founders since 2023',
        cofounderCEO: 'Co-founder and CEO',
        cofounderCTO: 'Co-founder and CTO',
        cofounderCFO: 'Co-founder and CFO'
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== KARRIERE PAGE ====================
    karrierePage: {
      hero: {
        title: 'Join Our Team',
        subtitle: 'Shape the future of transportation with us'
      },
      main: {
        heading: 'Are you a talented dev with references and just as passionate about planning optimization as the rest of us?',
        description: 'Become part of our 7-person team and show us live in an interview what you\'ve got.',
        ctaButton: 'Apply Now',
        stats: {
          teamMembers: {
            value: '7',
            label: 'Team Members'
          },
          remote: {
            value: '100%',
            label: 'Remote Possible'
          },
          growth: {
            value: '∞',
            label: 'Growth'
          }
        }
      },
      benefits: {
        title: 'What We Offer',
        items: [
          {
            title: 'State-of-the-Art Technology',
            description: 'Work with cutting-edge tools and technologies on exciting challenges'
          },
          {
            title: 'Flexible Work',
            description: 'Remote-first culture with flexible working hours and home office options'
          },
          {
            title: 'Personal Development',
            description: 'Continuous training and career development in a growing team'
          }
        ]
      }
    },

    // ==================== BETRIEBSKOSTEN SENKEN PAGE ====================
    betriebskostenSenkenPage: {
      hero: {
        title: 'Reduce Operating Costs',
        subtitle: 'With smarter planning and efficient operations',
        description: 'For operators of local public transport, it is becoming increasingly difficult to operate economically due to rising fuel, labor and service costs. BusAgent helps transport companies and authorities reduce expenses by optimizing vehicle utilization and eliminating inefficiencies. From planning to operations, every shift, every trip is optimally utilized without compromising service.',
        ctaButton: 'REQUEST CONTACT'
      },
      costReduction: {
        title: 'Reduce Costs Without Service Restrictions',
        description: 'Vehicle costs are one of the biggest expenses for operators. By reducing PVR (Peak Vehicle Requirement), you can achieve significant savings without compromising service quality.',
        diagram: {
          busAgent: 'BusAgent',
          optimization: 'Optimization',
          savings: 'Savings',
          pvrReduction: 'PVR Reduction',
          emptyRuns: 'Empty runs daily',
          totalSavings: 'Savings'
        }
      },
      costFeatures: {
        items: [
          {
            title: 'Reduce PVR',
            description: 'Optimize route and schedule planning to maximize vehicle utilization and reduce the number of vehicles needed.'
          },
          {
            title: 'Minimize Repairs',
            description: 'Reduce maintenance costs through intelligent vehicle assignment and save not only fuel but also wear and tear costs with every kilometer.'
          },
          {
            title: 'Save Fuel',
            description: 'Optimize fuel efficiency through intelligent vehicle allocation and route optimization.'
          }
        ]
      },
      efficiency: {
        title: 'Improve Employee and Process Efficiency',
        description: 'Planning is constantly changing and service must adapt to new requirements. With BusAgent, you can respond flexibly to changes while increasing employee efficiency.',
        diagram: {
          employeeA: 'Employee A',
          shiftRequest: 'Shift Request',
          busAgent: 'BusAgent',
          autoProcessing: 'Automatic Processing',
          employeeB: 'Employee B',
          confirmation: 'Confirmation'
        }
      },
      processFeatures: {
        items: [
          {
            title: 'Balance Shifts',
            description: 'Create fair and efficient shift plans that consider both operational requirements and employee needs.'
          },
          {
            title: 'Automate Shift Swaps',
            description: 'Automate shift swapping between employees and reduce administrative effort.'
          },
          {
            title: 'Prevent Delays',
            description: 'Use real-time tracking and intelligent planning to minimize delays and improve punctuality.'
          },
          {
            title: 'Optimize Payroll',
            description: 'Automate time tracking and payroll for more accurate and faster processes.'
          }
        ]
      },
      connectedPlatform: {
        title: 'Work Smarter with a Connected Platform',
        description: 'Unify your systems and data on one platform. No more isolated data silos - all information is connected and synchronized.'
      },
      finalCta: {
        title: 'Get more out of every kilometer, every shift and every euro',
        subtitle: 'With BusAgent you can reduce costs while improving service quality. Smarter planning leads to better results.',
        question: 'Are you ready to achieve more with less? Let\'s get started.',
        ctaButton: 'REQUEST CONTACT'
      },
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    },

    // ==================== KONTAKT PAGE ====================
    kontaktPage: {
      hero: {
        title: 'Contact Us'
      },
      form: {
        name: 'Name',
        email: 'Business Email',
        emailLink: 'No business email? Click here',
        company: 'Company Name',
        jobTitle: 'Job Title',
        phone: 'Phone Number',
        inquiry: 'Type of Inquiry',
        country: 'Country',
        organization: 'Type of Organization',
        assistance: 'Type of Assistance',
        message: 'Message',
        required: '*',
        optional: '(optional)',
        errorRequired: 'Please fill in this required field.',
        placeholders: {
          select: 'Select...'
        },
        options: {
          inquiry: {
            demo: 'BusAgent Software',
            partnership: 'Partnership',
            other: 'Other'
          },
          country: {
            de: 'Germany',
            uk: 'United Kingdom',
            other: 'Other'
          },
          organization: {
            transit: 'Transit Company',
            government: 'Government Agency',
            private: 'Private Operator',
            consultant: 'Consultant',
            other: 'Other'
          },
          assistance: {
            all: 'Everything',
            planning: 'Route Planning',
            scheduling: 'Scheduling',
            operations: 'Operations',
            other: 'Other'
          }
        }
      },
      privacy: 'BusAgent needs the contact information you provide to inform you about our products and services. You can unsubscribe from this communication at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please refer to our Privacy Policy.',
      submit: 'SUBMIT',
      cta: {
        title: 'See for yourself the performance of BusAgent.',
        button: 'REQUEST CONTACT'
      }
    }
  }
};
